<!-- workbench 主页 -->
<template>
  <div class="workbench_style" v-loading="data.workBenchLoading">
    <!-- <div class="workbench_top_style">
      <div class="meunLeft">
        <div class="logoHDY" @click="goToHomePage()">
          <img src="@/assets/svg/haidayuan.svg" style="vertical-align: middle" />
        </div>
      </div>
      <div :class="userData.supplyName && userData.supplyName.length > 4 ? 'meunMiddleB' : 'meunMiddleS'">
        <div class="menu_main">
        </div>
      </div>
      <div class="menuRight">
        <div class="menuRight2">
          <div class="menuRight2_text">
            {{ userData.roleName }}
          </div>
          <el-popover title="切换角色：" :visible="data.userChangeFlag">
            <div :class="item === userData.roleName ? 'menuRight2_user_blue' : 'menuRight2_user'" v-for="item in userData.roleNameList" @click="changeUserRole(item)">{{ item }}</div>
            <template #reference>
              <div class="menuRight2_down" @click="openUserChange()"></div>
            </template>
          </el-popover>
        </div>
        <div class="menuRight3">
          <img class="menuRight3_image" src="@/assets/svg/user.svg" align="center" style="height: 21px; width: 21px;" />
          <el-popover title="您好" :visible="data.logoutFlag">
            <div>{{ userData.supplyName }}</div>
            <div class="menuRight3_logout" @click="logOutFun()">退出</div>
            <template #reference>
              <span class="menuRight3_text" @click="data.logoutFlag = !data.logoutFlag , data.userChangeFlag ? data.userChangeFlag = false : ''">
                {{ userData.supplyName }}
              </span>
            </template>
          </el-popover>
        </div>
      </div>
    </div> -->
    <div class="workbench_middle_style">
      <div class="workbench_middle_left_style">
        <div class="workbench_middle_left_line_style">
        <div class="workbench_middle_left_one_style">
          <div class="backlog clearfix">
              <div class="personalInformation">
                <p class="title">{{ h_i18n('eab1293c98ed5068dfa21a2507603f2b') }}</p>
                <div class="per_footer">
                  <img src="../assets/images/个人信息头像.png" alt="">
                  <div class="per_f_right">
                    <p class="nameText">
                              <span class="text_name">
                                 {{ userData.trueName }}
                              </span>
                      <span style="font-size:15px;color:#fff;">{{ language_tab() != 'zh-CN' ? h_i18n(roleName[userData.roleName]) : userData.roleName }}</span>
                    </p>
                    <p style="font-size:14px;color:#fff;margin-bottom:8px;">{{ userData.supplyName }}</p>
                    <p style="font-size:12px;border-radius:10px;
                        background: rgb(255, 255, 255);line-height:20px;padding-left:10px;margin-right:10px;color:#6681f8;">{{ h_i18n('1211a84a5a38911aad0d69e27cee9054') }}</p>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div class="workbench_middle_left_two_style">
          <div class="monthly_portrait">
              <p class="monthly_portrait_p">
              <span class="monthly_portrait_title">{{ h_i18n('6feeabc2110fc6f2a8b36d10f757b9bc') }}</span>
            </p>
          </div>
          <div class="monthly_portrait_bottom_style">
            <div class="monthly_portrait_div_style">
              <div class="monthly_portrait_div_c1_style" :title="language_tab() != 'zh-CN' ? h_i18n('79d3506722d496c8e6eb5d4e3717e45e') : ''">{{ h_i18n('79d3506722d496c8e6eb5d4e3717e45e') }}</div>
              <div class="monthly_portrait_div_c2_style">{{ data.newProductCount }}</div>
            </div>
            <div class="monthly_portrait_div_style">
              <div class="monthly_portrait_div_c1_style" :title="language_tab() != 'zh-CN' ? h_i18n('f99f1782be6b50a8b3f0d4f090fdd46f') : ''">{{ h_i18n('f99f1782be6b50a8b3f0d4f090fdd46f') }}</div>
              <div class="monthly_portrait_div_c2_style">{{ data.stopCount }}</div>
            </div>
            <div class="monthly_portrait_div_style">
              <div class="monthly_portrait_div_c1_style" :title="language_tab() != 'zh-CN' ? h_i18n('a99004fa2089ee2eeec6a940b24685c0') : ''">{{ h_i18n('a99004fa2089ee2eeec6a940b24685c0') }}</div>
              <div class="monthly_portrait_div_c2_style">{{ data.complainCount }}</div>
            </div>
            </div>
        </div>
        </div>
        
        <div class="workbench_middle_left_three_style" >
          <div class="scene">
          <p class="scene_header">
            <!-- <span class="scene_header_text">工作场景</span> -->
          </p>
          <div class="scene_tabs_style">
              <el-tabs v-model="data.activeNameOfScene" class="demo-tabs" @tab-click="handleClickScene" :key="language_tab()">
                <el-tab-pane :label="h_i18n('a8b0c20416853bda54120bf19477ad11')" name="allMenu"></el-tab-pane>
                <el-tab-pane :label="h_i18n('b6bcde9ee2f8b6677507b96f7618d2ab')" :name="h_i18n('b6bcde9ee2f8b6677507b96f7618d2ab')"></el-tab-pane>
                <el-tab-pane :label="h_i18n('e5260d48222e5608f2d5ba0549107ecf')" :name="h_i18n('e5260d48222e5608f2d5ba0549107ecf')"></el-tab-pane>
                <el-tab-pane :label="h_i18n('3b9d92eca3709a56edfed5be784406cb')" :name="h_i18n('3b9d92eca3709a56edfed5be784406cb')"></el-tab-pane>
                <el-tab-pane :label="h_i18n('daa0d8109abe1b8f64c2802b5bc262a1')" :name="h_i18n('daa0d8109abe1b8f64c2802b5bc262a1')"></el-tab-pane>
                <el-tab-pane :label="h_i18n('ab49455cef77b5ba5df5aea1f604780f')" :name="h_i18n('ab49455cef77b5ba5df5aea1f604780f')"></el-tab-pane>
                <!-- <el-tab-pane :label="h_i18n('7b6c98d3716aab14ac250aef9fdf6079')" :name="h_i18n('7b6c98d3716aab14ac250aef9fdf6079')"></el-tab-pane> -->
              </el-tabs>
            </div>
          <ul v-if="data.activeNameOfScene === 'allMenu'" v-loading="data.menuLoading">
            <li @click="navigateTo(14)" v-if="hasPermission(14,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s005.png" alt=""/>
              <p>{{ h_i18n('fbea1c48071d7e43df61837cdfbd8a96') }}</p>
            </li>
            <li @click="navigateTo(1490)" v-if="hasPermission(1490,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s005.png" alt=""/>
              <!-- 新品质量（旧） -->
              <p>{{h_i18n('E6CCED320EA8395E16086890830D208D')}}</p>
            </li>
            <li @click="navigateTo(21)" v-if="hasPermission(21,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s006.png" alt=""/>
              <p>{{ h_i18n('96b190ab78a6f3c744fa3d56677e1d14') }}</p>
            </li>
            <li @click="navigateTo(7)" v-if="hasPermission(7,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s004.png" alt=""/>
              <p>{{ h_i18n('f7ef9633c64559e80c654567ca5ddd96') }}</p>
            </li>
            <li @click="navigateTo(399)" v-if="hasPermission(399,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/blss.png" alt="">
              <p>{{ h_i18n('a22da82fdca28ed11bed397e21b0c8b4') }}</p>
            </li>
            <!-- <li @click="navigateTo(420)" v-if="hasPermission(420,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/blss.png" alt=""/>
              <p>{{ h_i18n('a22da82fdca28ed11bed397e21b0c8b4') }}</p>
            </li> -->
            <li @click="navigateTo(41)" v-if="hasPermission(41,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s011.png" alt=""/>
              <p>{{ h_i18n('db18bb70398e600fad706d55fb3afb94') }}</p>
            </li>
            <li @click="navigateTo(103)" v-if="hasPermission(103,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s012.png" alt=""/>
              <p>{{ h_i18n('515ddeee81af7132f758a3c4a18f1cef') }}</p>
            </li>
            <li @click="navigateTo(58)" v-if="hasPermission(58,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/tianyan.png" alt=""/>
              <p>{{ h_i18n('f426a7bbab7ac4abd7d4b94e5817eee9') }}</p>
            </li>
            <li @click="navigateTo(33)" v-if="hasPermission(33,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s007.png" alt=""/>
              <p>{{ h_i18n('aa2647b3b17d7e74d1730d9cd7a4bb2b') }}</p>
            </li>
            <li @click="navigateTo(38)" v-if="hasPermission(38,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s010.png" alt=""/>
              <p>{{ h_i18n('3e1cb90cfee90167d41ab7503eba5daf') }}</p>
            </li>
            <li @click="navigateTo(49)" v-if="hasPermission(49,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s013.png" alt=""/>
              <p>{{ h_i18n('0be0fcb5e2ef6b3333b475ae869a85c5') }}</p>
            </li>
            <li @click="navigateTo(56)" v-if="hasPermission(56,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s015.png" alt=""/>
              <p>{{ h_i18n('d9e8fa0de4638ad402ecb62062882349') }}</p>
            </li>
            <li @click="navigateTo(302)" v-if="hasPermission(302,'All') && data.isBOM">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s008.png" alt=""/>
              <p>{{ h_i18n('d1d05a6da1e62dd4a6462ebe2fd7aaad') }}</p>
            </li>
            <li @click="navigateTo(304)" v-if="hasPermission(304,'All') && data.isBOM">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s008.png" alt=""/>
              <p>{{ h_i18n('7b57bae3d9823169ad1dcc26afd99109') }}</p>
            </li>
            <li @click="navigateTo(60)" v-if="hasPermission(60,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s016.png" alt=""/>
              <p>{{ h_i18n('1d3da79822f03f22f73ca43974d8a15a') }}</p>
            </li>
            <li @click="navigateTo(62)" v-if="hasPermission(62,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s017.png" alt=""/>
              <p>{{ h_i18n('93fbc4b2599c08ddc368dfc24ca259e2') }}</p>
            </li>
            <li @click="navigateTo(64)" v-if="hasPermission(64,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s018.png" alt=""/>
              <p>{{ h_i18n('0addf9d81daedc6979addd92d00e46c1') }}</p>
            </li>
            <li @click="navigateTo(66)" v-if="hasPermission(66,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s019.png" alt=""/>
              <p>{{ h_i18n('f37dba0758deb9ad0bead5f15776dd35') }}</p>
            </li>
            <li @click="navigateTo(68)" v-if="hasPermission(68,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s020.png" alt=""/>
              <p>{{ h_i18n('45f148242e1d295b25aebfecd99fa0ec') }}</p>
            </li>
            <li @click="navigateTo(70)" v-if="hasPermission(70,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s021.png" alt=""/>
              <p>{{ h_i18n('327b8141aa34a7e4294c6aba8f0d8756') }}</p>
            </li>
            <li @click="navigateTo(74)" v-if="hasPermission(74,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s023.png" alt=""/>
              <p>{{ h_i18n('2fe2b52941e1580031f4156430ae38ee') }}</p>
            </li>
            <li @click="navigateTo(341)" v-if="hasPermission(341,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s009.png" alt=""/>
              <p>{{ h_i18n('6678172a32b1b7a2d056bda472aee0fb') }}</p>
            </li>
            <li @click="navigateTo(83)" v-if="hasPermission(83,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s026.png" alt=""/>
              <p>{{ h_i18n('8fca15422833b617f9ff40381a3a01a5') }}</p>
            </li>
            <li @click="navigateTo(87)" v-if="hasPermission(87,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s009.png" alt=""/>
              <p>{{ h_i18n('4cbd267973099462346173a3cc9396b5') }}</p>
            </li>
            <li @click="navigateTo(72)" v-if="hasPermission(72,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s022.png" alt=""/>
              <p>{{ h_i18n('589a2a3b081eac7000558be56ae3a9a6') }}</p>
            </li>
            <li @click="navigateTo(77)" v-if="hasPermission(77,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s024.png" alt=""/>
              <p>{{ h_i18n('daa0d8109abe1b8f64c2802b5bc262a1') }}</p>
            </li>
            <li @click="navigateTo(82)" v-if="hasPermission(82,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s025.png" alt=""/>
              <p>{{ h_i18n('e0cc45dce91f8b0f92578d2d75ad7e21') }}</p>
            </li>
            <li @click="navigateTo(2)" v-if="hasPermission(2,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s001.png" alt=""/>
              <p>{{ h_i18n('37449bad8f75c8a898df87140c13b186') }}</p>
            </li>
            <li @click="navigateTo(3)" v-if="hasPermission(3,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s002.png" alt=""/>
              <p>{{ h_i18n('5a21fc3a56a003ace034e495154048e8') }}</p>
            </li>
            <li @click="navigateTo(4)" v-if="hasPermission(4,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s003.png" alt=""/>
              <p>{{ h_i18n('0398c352e892af3d3ec61bf0aaba5912') }}</p>
            </li>
            <li @click="navigateTo(54)" v-if="hasPermission(54,'All')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s014.png" alt=""/>
              <p>{{ h_i18n('1e186f08b3ffaaa601af98f9a9941e5a') }}</p>
            </li>
            <!-- <li @click="navigateTo(89)" v-if="hasPermission(89,'All') && userData.hCode === 0">
              <div class="hover_div_style"></div>
              <img src="../assets/images/xpgch_new.png" alt=""/>
              <p>{{ h_i18n('941566ff4288037319f067545f6f7e3c') }}</p>
            </li> -->

            <div style="margin: auto;" v-if="data.activeNameOfSceneAllFlag">
              <div class="hover_div_style"></div>
              <img src="../assets/img/no-data.png" width="96" height="96" />
              <div class="nodata-style">{{ h_i18n('8593ad610fffc49e27ce2cc35c92ca7e') }}</div>
            </div>
          </ul>
          <ul v-if="data.activeNameOfScene === h_i18n('b6bcde9ee2f8b6677507b96f7618d2ab')">
            <li @click="navigateTo(14)" v-if="hasPermission(14,'A')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s005.png" alt=""/>
              <p>{{ h_i18n('fbea1c48071d7e43df61837cdfbd8a96') }}</p>
            </li>
            <li @click="navigateTo(1490)" v-if="hasPermission(1490,'A')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s005.png" alt=""/>
              <!-- 新品质量（旧） -->
              <p>{{h_i18n('E6CCED320EA8395E16086890830D208D')}}</p>
            </li>
            <li @click="navigateTo(21)" v-if="hasPermission(21,'A')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s006.png" alt=""/>
              <p>{{ h_i18n('96b190ab78a6f3c744fa3d56677e1d14') }}</p>
            </li>
            <li @click="navigateTo(7)" v-if="hasPermission(7,'A')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s004.png" alt=""/>
              <p>{{ h_i18n('f7ef9633c64559e80c654567ca5ddd96') }}</p>
            </li>
            <li @click="navigateTo(399)" v-if="hasPermission(399,'A')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/blss.png" alt="">
              <p>{{ h_i18n('a22da82fdca28ed11bed397e21b0c8b4') }}</p>
            </li>
            <li @click="navigateTo(420)" v-if="hasPermission(420,'A')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/blss.png" alt=""/>
              <p>{{ h_i18n('a22da82fdca28ed11bed397e21b0c8b4') }}</p>
            </li>
            <div style="margin: auto;" v-if="data.activeNameOfSceneAFlag">
              <div class="hover_div_style"></div>
              <img src="../assets/img/no-data.png" width="96" height="96" />
              <div class="nodata-style">{{ h_i18n('8593ad610fffc49e27ce2cc35c92ca7e') }}</div>
            </div>
          </ul>
          <ul v-else-if="data.activeNameOfScene === h_i18n('e5260d48222e5608f2d5ba0549107ecf')">
            <li @click="navigateTo(41)" v-if="hasPermission(41,'B')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s011.png" alt=""/>
              <p>{{ h_i18n('db18bb70398e600fad706d55fb3afb94') }}</p>
            </li>
            <li @click="navigateTo(103)" v-if="hasPermission(103,'B')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s012.png" alt=""/>
              <p>{{ h_i18n('515ddeee81af7132f758a3c4a18f1cef') }}</p>
            </li>
            <li @click="navigateTo(58)" v-if="hasPermission(58,'B')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/tianyan.png" alt=""/>
              <p>{{ h_i18n('f426a7bbab7ac4abd7d4b94e5817eee9') }}</p>
            </li>
            <li @click="navigateTo(33)" v-if="hasPermission(33,'B')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s007.png" alt=""/>
              <p>{{ h_i18n('aa2647b3b17d7e74d1730d9cd7a4bb2b') }}</p>
            </li>
            <!-- <li @click="navigateTo('称重检测')" v-if="hasPermission('称重检测','B')">
              <img src="../assets/images/s008.png" alt="">
              <p>称重检测</p>
            </li> -->
            <!-- <li @click="navigateTo('质量体系自查')" v-if="hasPermission('质量体系自查','B')">
              <img src="../assets/images/s009.png" alt="">
              <p>质量体系自查</p>
            </li> -->
            <li @click="navigateTo(38)" v-if="hasPermission(38,'B')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s010.png" alt=""/>
              <p>{{ h_i18n('3e1cb90cfee90167d41ab7503eba5daf') }}</p>
            </li>
            <li @click="navigateTo(49)" v-if="hasPermission(49,'B')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s013.png" alt=""/>
              <p>{{ h_i18n('0be0fcb5e2ef6b3333b475ae869a85c5') }}</p>
            </li>
            <li @click="navigateTo(56)" v-if="hasPermission(56,'B')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s015.png" alt=""/>
              <p>{{ h_i18n('d9e8fa0de4638ad402ecb62062882349') }}</p>
            </li>
            <li @click="navigateTo(302)" v-if="hasPermission(302,'B') && data.isBOM">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s008.png" alt=""/>
              <p>{{ h_i18n('d1d05a6da1e62dd4a6462ebe2fd7aaad') }}</p>
            </li>
            <li @click="navigateTo(304)" v-if="hasPermission(304,'B') && data.isBOM">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s008.png" alt=""/>
              <p>{{ h_i18n('7b57bae3d9823169ad1dcc26afd99109') }}</p>
            </li>
            <div style="margin: auto;" v-if="data.activeNameOfSceneBFlag">
              <div class="hover_div_style"></div>
              <img src="../assets/img/no-data.png" width="96" height="96" />
              <div class="nodata-style">{{ h_i18n('8593ad610fffc49e27ce2cc35c92ca7e') }}</div>
            </div>
          </ul>
          <ul v-else-if="data.activeNameOfScene === h_i18n('3b9d92eca3709a56edfed5be784406cb')">
            <li @click="navigateTo(60)" v-if="hasPermission(60,'C')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s016.png" alt=""/>
              <p>{{ h_i18n('1d3da79822f03f22f73ca43974d8a15a') }}</p>
            </li>
            <li @click="navigateTo(62)" v-if="hasPermission(62,'C')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s017.png" alt=""/>
              <p>{{ h_i18n('93fbc4b2599c08ddc368dfc24ca259e2') }}</p>
            </li>
            <li @click="navigateTo(64)" v-if="hasPermission(64,'C')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s018.png" alt=""/>
              <p>{{ h_i18n('0addf9d81daedc6979addd92d00e46c1') }}</p>
            </li>
            <li @click="navigateTo(66)" v-if="hasPermission(66,'C')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s019.png" alt=""/>
              <p>{{ h_i18n('f37dba0758deb9ad0bead5f15776dd35') }}</p>
            </li>
            <li @click="navigateTo(68)" v-if="hasPermission(68,'C')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s020.png" alt=""/>
              <p>{{ h_i18n('45f148242e1d295b25aebfecd99fa0ec') }}</p>
            </li>
            <li @click="navigateTo(70)" v-if="hasPermission(70,'C')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s021.png" alt=""/>
              <p>{{ h_i18n('327b8141aa34a7e4294c6aba8f0d8756') }}</p>
            </li>
            <li @click="navigateTo(74)" v-if="hasPermission(74,'C')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s023.png" alt=""/>
              <p>{{ h_i18n('2fe2b52941e1580031f4156430ae38ee') }}</p>
            </li>
            <li @click="navigateTo(341)" v-if="hasPermission(341,'C')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s009.png" alt=""/>
              <p>{{ h_i18n('6678172a32b1b7a2d056bda472aee0fb') }}</p>
            </li>
            <li @click="navigateTo(83)" v-if="hasPermission(83,'C')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s026.png" alt=""/>
              <p>{{ h_i18n('8fca15422833b617f9ff40381a3a01a5') }}</p>
            </li>
            <li @click="navigateTo(87)" v-if="hasPermission(87,'C')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s009.png" alt=""/>
              <p>{{ h_i18n('4cbd267973099462346173a3cc9396b5') }}</p>
            </li>
            <li @click="navigateTo(72)" v-if="hasPermission(72,'C')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s022.png" alt=""/>
              <p>{{ h_i18n('589a2a3b081eac7000558be56ae3a9a6') }}</p>
            </li>
            <div style="margin: auto;" v-if="data.activeNameOfSceneCFlag">
              <div class="hover_div_style"></div>
              <img src="../assets/img/no-data.png" width="96" height="96" />
              <div class="nodata-style">{{ h_i18n('8593ad610fffc49e27ce2cc35c92ca7e') }}</div>
            </div>
          </ul>
          <ul v-else-if="data.activeNameOfScene === h_i18n('daa0d8109abe1b8f64c2802b5bc262a1')">
            <li @click="navigateTo(77)" v-if="hasPermission(77,'D')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s024.png" alt=""/>
              <p>{{ h_i18n('daa0d8109abe1b8f64c2802b5bc262a1') }}</p>
            </li>
            <!-- <li @click="navigateTo('绩效评价')" v-if="hasPermission('绩效评价','D')">
              <p>绩效评价</p>
            </li> -->
            <li @click="navigateTo(82)" v-if="hasPermission(82,'D')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s025.png" alt=""/>
              <p>{{ h_i18n('e0cc45dce91f8b0f92578d2d75ad7e21') }}</p>
            </li>
            <div style="margin: auto;" v-if="data.activeNameOfSceneDFlag">
              <div class="hover_div_style"></div>
              <img src="../assets/img/no-data.png" width="96" height="96" />
              <div class="nodata-style">{{ h_i18n('8593ad610fffc49e27ce2cc35c92ca7e') }}</div>
            </div>
          </ul>
          <ul v-else-if="data.activeNameOfScene === h_i18n('ab49455cef77b5ba5df5aea1f604780f')">
            <li @click="navigateTo(2)" v-if="hasPermission(2,'E')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s001.png" alt=""/>
              <p>{{ h_i18n('37449bad8f75c8a898df87140c13b186') }}</p>
            </li>
            <li @click="navigateTo(3)" v-if="hasPermission(3,'E')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s002.png" alt=""/>
              <p>{{ h_i18n('5a21fc3a56a003ace034e495154048e8') }}</p>
            </li>
            <li @click="navigateTo(4)" v-if="hasPermission(4,'E')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s003.png" alt=""/>
              <p>{{ h_i18n('0398c352e892af3d3ec61bf0aaba5912') }}</p>
            </li>
            <li @click="navigateTo(54)" v-if="hasPermission(54,'E')">
              <div class="hover_div_style"></div>
              <img src="../assets/images/s014.png" alt=""/>
              <p>{{ h_i18n('1e186f08b3ffaaa601af98f9a9941e5a') }}</p>
            </li>
            <div style="margin: auto;" v-if="data.activeNameOfSceneEFlag">
              <div class="hover_div_style"></div>
              <img src="../assets/img/no-data.png" width="96" height="96" />
              <div class="nodata-style">{{ h_i18n('8593ad610fffc49e27ce2cc35c92ca7e') }}</div>
            </div>
          </ul>
          <!-- <ul v-else-if="data.activeNameOfScene === h_i18n('7b6c98d3716aab14ac250aef9fdf6079')">
            <li @click="navigateTo(89)" v-if="hasPermission(89,'F') && userData.hCode === 0">
              <div class="hover_div_style"></div>
              <img src="../assets/images/xpgch_new.png" alt=""/>
              <p>{{ h_i18n('941566ff4288037319f067545f6f7e3c') }}</p>
            </li>
            <div style="margin: auto;" v-if="data.activeNameOfSceneFFlag || userData.hCode !== 0">
              <div class="hover_div_style"></div>
              <img src="../assets/img/no-data.png" width="96" height="96" />
              <div class="nodata-style">{{ h_i18n('8593ad610fffc49e27ce2cc35c92ca7e') }}</div>
            </div>
          </ul> -->
        </div>
        </div>
        <div class="workbench_middle_left_four_style">
          <div class="todo_list_style">
            <div class="todo_list_title_style">
              <!-- <span>待办场景</span> -->
            </div>
            <div class="todo_list_tabs_style">
              <el-tabs v-model="data.activeNameOfTodo" class="demo-tabs" @tab-click="handleClickTodo" :key="language_tab()">
                <el-tab-pane :label="h_i18n('fbea1c48071d7e43df61837cdfbd8a96')" name="新品质量" :disabled="data.myTodoListLoading"></el-tab-pane>
                <el-tab-pane :label="h_i18n('7a4bf767a46b328eb61fca6ba1659b70')" name="过程质量" :disabled="data.myTodoListLoading"></el-tab-pane>
                <el-tab-pane :label="h_i18n('3b9d92eca3709a56edfed5be784406cb')" name="质量改善" :disabled="data.myTodoListLoading"></el-tab-pane>
                <!-- <el-tab-pane label="课程学习" name="课程学习"></el-tab-pane> -->
              </el-tabs>
            </div>
            <div class="todo_list_right_title_style">
              <!-- <span>合计 </span>
              <span>已处理 </span>
              <span>待处理 </span>
              <span>拖期 </span> -->
            </div>
            <todo_card ref="refOfTodo" :queryData="userData" @getTodoList="getTodo" @changeRouter="changeRouterTodo" @todoLoading="onTodoLoading"></todo_card>
          </div>
        </div>
        <div class="workbench_middle_left_five_style" >
          <div class="datareport">
              <div class="datareport_header">
                <!-- <span class="datareport_header_text">我的数据</span> -->
                <div class="datareport_tabs_style">
                  <el-tabs v-model="data.activeNameOfDatareport" class="demo-tabs" @tab-click="handleClickDatareport" :key="language_tab()">
                  <el-tab-pane :label="h_i18n('1d3da79822f03f22f73ca43974d8a15a')" name="入厂不合格">
                    <template #label>
                      <span class="custom-tabs-label">
                        <span>{{ h_i18n('1d3da79822f03f22f73ca43974d8a15a') }}</span>
                        <el-tooltip class="box-item" effect="dark" :content="h_i18n('1d3da79822f03f22f73ca43974d8a15a')" placement="top">
                          <info theme="outline" style="padding-left: 8px;vertical-align: middle;"/>
                        </el-tooltip>
                      </span>
                    </template>
                  </el-tab-pane>
                  <el-tab-pane :label="h_i18n('21b7c71be5da16a8e5a84440fe0d1327')" name="模块停检">
                    <template #label>
                      <span class="custom-tabs-label">
                        <span>{{ h_i18n('21b7c71be5da16a8e5a84440fe0d1327') }}</span>
                        <el-tooltip class="box-item" effect="dark" :content="h_i18n('21b7c71be5da16a8e5a84440fe0d1327')" placement="top">
                          <info theme="outline" style="padding-left: 8px;vertical-align: middle;"/>
                        </el-tooltip>
                      </span>
                    </template>
                  </el-tab-pane>
                  <el-tab-pane :label="h_i18n('a0d74f6dc6eab5984313736ec1910bf6')" name="质量损失">
                    <template #label>
                      <span class="custom-tabs-label">
                        <span>{{ h_i18n('a0d74f6dc6eab5984313736ec1910bf6') }}</span>
                        <el-tooltip class="box-item" effect="dark" :content="h_i18n('a0d74f6dc6eab5984313736ec1910bf6')" placement="top">
                          <info theme="outline" style="padding-left: 8px;vertical-align: middle;"/>
                        </el-tooltip>
                      </span>
                    </template>
                  </el-tab-pane>
                  <!-- <el-tab-pane label="质量得分" name="质量得分"></el-tab-pane> -->
                </el-tabs>
                </div>

                <div class="datareport_date_style">
                  <h-list-page-new :class="language_tab() != 'zh-CN' ? 'datareport_date_page_style_en' : 'datareport_date_page_style'">
                    <h-search :title="h_i18n('92bf57b7dcb38847b483bb3a7ece3ae3')">
                      <h-date-picker-new type="monthrange" v-model="searchData.searchDate" range-separator="-"
                            :start-placeholder="h_i18n('8749d983883ab46745aaac730f398a97')" :end-placeholder="h_i18n('3b0575e9cc5ccd3824e6461b8b1f7107')" @change="TimeChange(searchData.searchDate, {start:'searchDateStart',end:'searchDateEnd'})"></h-date-picker-new>
                    </h-search>
                  </h-list-page-new>
                  <!-- <span>月份区间选择&nbsp;</span>
                  <el-date-picker v-model="searchData.searchDate" type="monthrange" range-separator="-" start-placeholder="开始月份" end-placeholder="结束月份"
                  @change="TimeChange(searchData.searchDate, {start:'searchDateStart',end:'searchDateEnd'})"/>                   -->
                </div>
                <div class="workbench_card_style">
                  <workbench_card :searchDateStart="searchData.searchDateStart" :searchDateEnd="searchData.searchDateEnd"
                  :activeNameOfDatareport="data.activeNameOfDatareport" :userData="userData" :endTime="searchData.searchDateEnd" :startTime="searchData.searchDateStart" ref="refOfDatareport">
                  </workbench_card>
                </div>
              </div>
            </div>
        </div>
        <div class="workbench_middle_left_six_style" >
          <div class="workbench_middle_left_six_title_style">
            <span>{{ h_i18n('a3a0cbcd55f8f7a9a401d5f8800c4c00') }}</span>
          </div>
          <ul>
            <li @click="navigateTo(92)" v-if="hasPermission(92)">
              <span>{{ h_i18n('e5d042ada56cafab87618e271c08daa0') }}</span>
            </li>
            <!-- <li @click="navigateTo('流程文件')" v-if="hasPermission('流程文件')">
              <span>流程文件</span>
            </li> -->
            <li @click="navigateTo(96)" v-if="hasPermission(96)">
              <span>{{ h_i18n('50d52dd929a75bb9b0f4afb0b7d879e1') }}</span>
            </li>
            <li @click="navigateTo(98)" v-if="hasPermission(98)">
            <!-- 联系我们 -->
              <span>{{ h_i18n('0cbf83cc07c9d82ce42fdb94880b20d5') }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="workbench_middle_right_style">
        <div class="workbench_middle_right_A_style">
          <div class="workbench_middle_right_notice_list_style">
            <el-tabs v-model="data.activeNameRightTodo" class="demo-tabs" @tab-click="handleClickactiveNameRightTodo" :key="language_tab()">
              <el-tab-pane :label="h_i18n('536d2e8eb010fd96198373de9012ead8')" name="我的待办"></el-tab-pane>
              <el-tab-pane name="我的通知" v-if="data.btnListOfSqm[0]?.code === 'mkhl_gzt_wdtz'">
                <template #label>
                  <el-badge :value="data.unreadNotifyCount" :hidden="data.unreadNotifyCount === 0" :max="99" class="notify_tab_badge">
                    <span>{{ h_i18n('f8b0c4f2e8d5a3c1b9e7d6f4a2c8b5e3') }}</span>
                  </el-badge>
                </template>
              </el-tab-pane>
            </el-tabs>
          </div>
          <!-- 我的待办内容 -->
          <div class="A_style" v-show="data.activeNameRightTodo === '我的待办'" v-loading="data.myTodoListLoading" >
            <div style="margin: auto;text-align: center;margin-top: calc(50% - 140px);" v-if="!data.myTodoList || data.myTodoList.length === 0">
              <img src="../assets/img/no-data.png" width="96" height="96" />
              <div class="nodata-style">{{ h_i18n('44406eaf8750d430f883a9981c1fbcb2') }}</div>
            </div>
            <div v-for="itemTodo in data.myTodoList" class="A_style_todo">
              <span class="A_style_todo_span" :title="language_tab() != 'zh-CN' ? `${itemTodo.name}${h_i18n('cc4ad2fd27e24ff9191e254d8576d2ba')}${itemTodo.number}${h_i18n('cc1bacb5117aa3f27e5e430cd28dbaed')}${itemTodo.statusName}`: ''">
                {{ itemTodo.name }}{{ h_i18n('cc4ad2fd27e24ff9191e254d8576d2ba') }}{{ itemTodo.number }}{{ h_i18n('cc1bacb5117aa3f27e5e430cd28dbaed') }}{{ itemTodo.statusName }}</span>
              <el-button type="primary" class="A_style_todo_button" size="small" @click="navigateToTodo(itemTodo)">{{ h_i18n('bfdd85e099565f0d30ee024c6a2f1d31') }}</el-button>
            </div>
          </div>
          <!-- 我的通知内容 -->
          <div class="A_style notify_content_style" v-show="data.activeNameRightTodo === '我的通知'" v-loading="data.myNotifyListLoading">
            <!-- 未读/已读/全部 + 查看更多 -->
            <div class="notify_sub_bar">
              <el-tabs v-model="data.notifyFilter" type="card" class="notify_filter_tabs" @tab-click="handleNotifyFilterChange">
                <el-tab-pane name="unread">
                  <template #label>{{ h_i18n('a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6') }} <em>{{ data.unreadNotifyCount }}</em></template>
                </el-tab-pane>
                <el-tab-pane name="read">
                  <template #label>{{ h_i18n('b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7') }} <em>{{ data.readNotifyCount }}</em></template>
                </el-tab-pane>
                <el-tab-pane name="all">
                  <template #label>{{ h_i18n('a8b0c20416853bda54120bf19477ad11') }} <em>{{ data.totalNotifyCount }}</em></template>
                </el-tab-pane>
              </el-tabs>
              <span class="notify_more_btn" @click="openNotifyDrawer">{{ h_i18n('44a1f0c7642ece07d7ed23c47da42b4c') }} ></span>
            </div>
            <!-- 通知列表 -->
            <div class="notify_card_list">
              <div style="margin: auto;text-align: center;padding: 40px 0;" v-if="!data.filteredNotifyList || data.filteredNotifyList.length === 0">
                <img src="../assets/img/no-data.png" width="96" height="96" />
                <div class="nodata-style">{{ h_i18n('f61f4cf6d0d544fad4507868b74696a1') + h_i18n('g1h2i3j4k5l6m7n8o9p0q1r2s3t4u5v6')}}</div>
              </div>
              <div v-for="item in data.filteredNotifyList" :key="item.id" class="notify_card_item" @click="markAsRead(item)">
                <div class="notify_card_left">
                  <el-tag :type="item.pushStatus === 1 ? 'warning' : 'success'" size="small">
                    {{ item.pushStatus === 1 ? h_i18n('a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6') : h_i18n('b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7') }}
                  </el-tag>
                </div>
                <div class="notify_card_right">
                  <div class="notify_card_content">{{ item.pushText }}</div>
                  <div class="notify_card_meta">
                    <img src="../assets/images/userIcon.png" width="14" height="14" style="vertical-align:middle;margin-right:4px;" />
                    <span>{{ time(item.pushDate) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 我的通知抽屉 -->
        <el-drawer v-model="data.notifyDrawerVisible" custom-class="notify_drawer_class" size="720px" direction="rtl" :show-close="true" :title="h_i18n('f8b0c4f2e8d5a3c1b9e7d6f4a2c8b5e3')" @close="onNotifyDrawerClose">
          <template #default>
            <h-list-page class="drawer_page">
              <h-card :title="h_i18n('b8fd5c6d8a6e6b652403c8fd7bbc79b1')" style="padding:0; margin-bottom:-10px;"
                  width="100%" :is-left="0" is-search :footer="false" @change-method="changeMethod">
                  <h-area>
                    <h-search :title="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')">
                      <h-select v-model="drawerSearch.pushStatus" :placeholder="h_i18n('a8b0c20416853bda54120bf19477ad11')" clearable>
                        <h-option :key="''" :label="h_i18n('a8b0c20416853bda54120bf19477ad11')" :value="''"></h-option>
                        <h-option :key="1" :label="h_i18n('a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6')" :value="1"></h-option>
                        <h-option :key="2" :label="h_i18n('b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7')" :value="2"></h-option>
                      </h-select>
                    </h-search>
                    <template #operate>
                      <h-button type="primary" :loading="loading" @click="handleCurrentChange()">
                        <template #icon>
                          <search />
                        </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}
                        </h-button>
                    </template>
                  </h-area>
              </h-card>
              <h-table-card :title="h_i18n('b8fd5c6d8a6e6b652403c8fd7bbc79b1')">
                <template #buttonGroup>
                  <h-button-group style="width: 80px;">
                    <!-- 已读按钮 -->
                    <h-button type="primary" @click="batchMarkAsRead()">{{ h_i18n('e83a256e4f5bb4ff8b3d804b5473217a') + h_i18n('b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7') }}</h-button>
                  </h-button-group>
                </template>
                <el-table border :data="data.drawerNotifyList" v-loading="data.drawerNotifyLoading" @selection-change="handleDrawerSelectionChange" style="width:100%;min-height: 240px" height="540px">
                  <el-table-column type="selection" width="50" :selectable="checkSelectable" />
                  <el-table-column :label="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')" width="80">
                    <template #default="{ row }">
                      <el-tag :type="row.pushStatus === 1 ? 'warning' : 'success'" size="small">
                        {{ row.pushStatus === 1 ? h_i18n('a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6') : h_i18n('b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7') }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column :label="h_i18n('g1h2i3j4k5l6m7n8o9p0q1r2s3t4u5v6')" prop="pushText" min-width="300" align="left"/>
                  <el-table-column :label="h_i18n('h2i3j4k5l6m7n8o9p0q1r2s3t4u5v6w7')" width="180">
                    <template #default="{ row }">{{ time(row.pushDate, 6) }}</template>
                  </el-table-column>
                </el-table>
              </h-table-card>
              <el-pagination background 
                layout="total, prev, pager, next,jumper" :total="data.drawerNotifyTotal"
                :page-size="data.drawerNotifyPageSize" v-model:current-page="data.drawerNotifyPageNo"
                @current-change="handleDrawerPageChange"/>
            </h-list-page>
          </template>
        </el-drawer>
        <div class="workbench_middle_right_B_style">
          <img class="workbench_middle_right_B_back_style" src="../assets/images/hdy_back.png"/>
          <div class="righ_link_style">
            <span style="background: linear-gradient(180.00deg, rgb(22, 179, 253),rgb(22, 92, 253));
            -webkit-background-clip: text; -webkit-text-fill-color: transparent;font-weight:800;display: block;
             font-size:26px;vertical-align: super;cursor: pointer;">
              {{ h_i18n('35EC7D9A18B8965D58220B5411F28568') }}
            </span>
            <br>
            <img src="../assets/images/hdy_link.png" />
            <span style="color:#165dff; font-size:16px;text-decoration:underline;vertical-align: super;margin-left: 10px;cursor: pointer;" @click="hdyClick()">
              {{ h_i18n('5d701a60a8010bc4b028078aab60d6e3') }}
            </span>
          </div>
        </div>
        <div class="workbench_middle_right_C_style">
          <div class="workbench_middle_right_notice_style">
            <el-tabs v-model="data.activeNameOfNotice" class="demo-tabs" @tab-click="handleClickNameOfNotice" :key="language_tab()">
              <el-tab-pane :label="h_i18n('1432c7fcdba00f248023082857b52281')" name="系统公告"></el-tab-pane>
              <el-tab-pane :label="h_i18n('20faa88f0d2f0ab5f771e88deb352132')" name="操作指导书"></el-tab-pane>
              <el-tab-pane :label="h_i18n('50d52dd929a75bb9b0f4afb0b7d879e1')" name="常见问题"></el-tab-pane>
            </el-tabs>
          </div>
          <div class="rightNotice_more_style" @click="openMore()">{{ h_i18n('44a1f0c7642ece07d7ed23c47da42b4c') }}</div>
          <div class="rightNotice_style" v-if="data.activeNameOfNotice === '系统公告'" v-loading="data.noticeLoading">
            <div class="right_notice_style" v-for="item in data.noticeList">
              <div class="rightNotice_style_left" @click="openUrl(item)">
                {{ item.fileName }}
              </div>
              <div class="rightNotice_style_date">
                {{ time(item.uploadTime) }}
              </div>
            </div>
          </div>
          <div class="rightNotice_style" v-if="data.activeNameOfNotice === '操作指导书'" v-loading="data.noticeLoading">
            <div class="right_notice_style" v-for="item in data.noticeList">
              <div class="rightNotice_style_left" @click="openUrl(item)">
                {{ item.fileName }}
              </div>
              <div class="rightNotice_style_date">
                {{ time(item.uploadTime) }}
              </div>
            </div>
          </div>
          <div class="rightNotice_style" v-if="data.activeNameOfNotice === '常见问题'" v-loading="data.noticeLoading">
            <div class="right_notice_style" v-for="item in data.noticeList">
              <div class="rightNotice_style_left" @click="openUrl(item)">
                {{ item.fileName }}
              </div>
              <div class="rightNotice_style_date">
                {{ time(item.uploadTime) }}
              </div>
            </div>
          </div>
        </div>
        <div class="workbench_middle_right_D_style"></div>
      </div>

    </div>
    <div class="workbench_bottom_style">

    </div>
    <Announcement shadow :data="anText"></Announcement>
  </div>
  <el-dialog v-model:visible="dialogVisible" title="" align-center >
    <div style="color: #FFF;font-size: 14px;">
      <div style="height: 30px;width: 812px;margin-top: -10px;font-size: 22px;
        text-align: center;text-indent: 0px;">{{ h_i18n('a7deb625ed114b6ec7e180526fe00a5e') }}</div>
      <div style="margin:20px 60px;line-height: 30px;">{{ h_i18n('C6160DF03C697F610263071D6AA1FD04') }}</div>
      <div style="margin-left: 60px;height:40px;width:692px;vertical-align: center;text-align: left;font-size: 18px;font-weight:bold;color:#FFF">{{ h_i18n('2DEA407D3380D9E1303B3F36DDA55AEF') }}:</div>
      <div style="margin-left: 80px;margin-right: 80px;">
        <p>{{ h_i18n('04B0C2D9063740E42C571C32BDA37A80') }}</p>
        <p>{{ h_i18n('70FDB017650511AEB8B17CFC0C7D0B94') }}</p>
      </div>
      <div style="margin-left: 60px;height:40px;width:692px;vertical-align: center;text-align: left;font-size: 18px;font-weight:bold;color:#FFF">{{ h_i18n('500893CCA7FE0D2400116675E1081728') }}:</div>
      <div style="margin-left: 80px;margin-right: 80px;">
        <p>1、{{ h_i18n('AA49FB23ECF9CACF2E8D41EB5247CF23') }}</p>
        <p>2、{{ h_i18n('59600C6BC4A5273CD87BC3D5889292C4') }}</p>
        <p>3、{{ h_i18n('DDB67AE16D0C9B9FB0DB6EA5B69F6408') }}</p>
        <p style="color:red">4、{{ h_i18n('D2B13102C1FC795201AE43AE1CD6097A') }}</p>
        <p>5、{{ h_i18n('39568518B9E661E4931286A351842C3E') }}</p>
        <br/>
        <p>{{ h_i18n('1177126c9088de02f8bc890ea72e993d') }}<a v-intercept-href href="https://sqm.haier.net/readFile/basicInfo/%E4%BE%9B%E5%BA%94%E5%95%86%E5%B8%82%E5%9C%BA%E7%94%9F%E6%80%81%E5%9C%88%E6%93%8D%E4%BD%9C%E6%8C%87%E5%AF%BC%E6%89%8B%E5%86%8C%E3%80%90SQM%E3%80%91.pdf" style="color:#5cd5fb;cursor:pointer;text-decoration:underline">{{ h_i18n('76d9a8b786c396065fe0a91c38f2fbee') }}</a>{{ h_i18n('81197c2d02b3a7c54cbd498ce55a73c8') }}</p>
      </div>
    </div>
  </el-dialog>
</template>
<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import { reactive, getCurrentInstance, onMounted, defineComponent, nextTick, onBeforeMount, onActivated, onDeactivated, ref, computed, watch } from 'vue';
  import { useRoute } from "vue-router";
  import workbench_card from "../components/workbenchCard"
  import todo_card from "../components/workbenchCard/todoCard.vue"
  import axios from "axios";
import { time } from "echarts";
  import Announcement from '@/base/Content/Announcement.vue';
import { useStore } from 'vuex';

  export default defineComponent({
    name: "workbench",
    components:{
      Announcement,
      workbench_card,
      todo_card,
    },
    props:{},
    setup(props, { emit }) {
      const roleName = ref({
        '总经理':'4E832C156E02EB36C511B72F181F1407',           
        '跟单（发货）经理':'0719A811A5CB01E10BDA4117301B03AC', 
        '质量经理':'1E39214858FFD6EB01F89694362C8166',         
        '质量部长':'D5F2B24D2A98170CFA0C0484D8ADA322',         
        '销售经理':'9AED4AD750E5E98E75A3B010F8F50884',         
      })
      const { proxy, ctx } = getCurrentInstance()
      const route = useRoute()
      const refOfDatareport = ref()
      const refOfTodo = ref()
      const userData = reactive({
        supplyCode: null,
        supplyName: null,
        roleCode: null,
        roleId: null,
        userCode: null,
        userName: null,
        userId: null,
        isSupply: null,
        type: null,
        status: null,
        // applyName: null,
        sqmToDoKey: null,
        // resourceId: null,
        parentId: null,
        dataFrom: 'sqm',
        trueName: null,
        roleName: null,
        // roleCodeList:[],
        // roleNameList:[],
        hCode: 1, // GCCC认证 0 显示
        vHcode: 0, // 芯片供应商 是否有其他菜单权限
      })
      const data = reactive({
        btnListOfSqm:[],
        workBenchLoading:false,
        imgHeight: 310,// 比例高度
        noticeSize:8,
        enterQuery: null,
        userChangeFlag :false,
        logoutFlag:false,
        activeNameOfDatareport:'入厂不合格',
        activeNameOfScene:'allMenu',
        activeNameOfTodo:'新品质量',
        activeNameRightTodo:'我的待办',
        activeNameOfNotice:'系统公告',
        activeNameOfSceneAllFlag:true, //模块有权限的菜单显隐
        activeNameOfSceneAFlag:true, //模块有权限的菜单显隐
        activeNameOfSceneBFlag:true, //模块有权限的菜单显隐
        activeNameOfSceneCFlag:true, //模块有权限的菜单显隐
        activeNameOfSceneDFlag:true, //模块有权限的菜单显隐
        activeNameOfSceneEFlag:true, //模块有权限的菜单显隐
        activeNameOfSceneFFlag:true, //模块有权限的菜单显隐
        menuList:[],
        menuLoading:false,
        complainCount:0, // 抱怨单数
        stopCount:0 , // 停检数
        newProductCount:0, // 新品报验数
        isBOM:true, // 接口获取，是否BOM供应商
        pathCode:'', //跳转code
        pathName:'', // 跳转name
        pathUrl:'' , // 跳转url
        myTodoList:[], // 待办列表
        myTodoListLoading:true,
        lineScoreTableData: [
          // TODO
          {line:h_i18n('351f023ca65048d35f5ba9a678397849'),score:200},{line:h_i18n('6e0c7d9c413ef2e4eb51f3e0bba90419'),score:20455678545670},{line:'testtesttest',score:300},{line:'ceshiceshi',score:200},{line:'sssssssssssssss',score:2100},{line:h_i18n('15992027ad912146532ef9d141b46e2e'),score:5200}] ,// 产线绩效得分表格
        resonList :[
          // TODO
          {supply:h_i18n('db06c78d1e24cf708a14ce81c9b617ec'),tactics:h_i18n('a0c83707b5438e080655df34a78142f4'),reson:h_i18n('b0da132423073fbcca7bd295ac4e8b89'),mounth:'2024-09'},
          {supply:h_i18n('857e00deaa295ff6373822c19bc5f98f'),tactics:h_i18n('857e00deaa295ff6373822c19bc5f98f'),reson:h_i18n('6e0c7d9c413ef2e4eb51f3e0bba90419'),mounth:'2024-10'},
          {supply:'test',tactics:'test',reson:'testtesttesttesttesttesttesttesttesttest',mounth:'2024-11'},
        ] ,// 执行策略原因
        resonIndex:1, // 原因翻页
        noticeList:[], // 公告
        noticeLoading:false,
        // 我的通知
        myNotifyList: [],
        filteredNotifyList: [],
        myNotifyListLoading: false,
        unreadNotifyCount: 0,
        readNotifyCount: 0,
        totalNotifyCount: 0,
        notifyFilter: 'all',
        notifyDrawerVisible: false,
        drawerNotifyList: [],
        drawerNotifyLoading: false,
        drawerNotifyPageNo: 1,
        drawerNotifyPageSize: 10,
        drawerNotifyTotal: 0,
        drawerSelectedRows: [],
      })
      const searchData = reactive({

      })
      const drawerSearch = reactive({
        pushStatus: null
      })
      const languageNo = ref(0)
      const store = useStore();
      watch(()=>store.state.i18n.language,()=>{
        if(languageNo.value === 0){
          languageNo.value ++ 
          return
        }else{
          handleClickTodo()
          refOfDatareport.value.changeOfDatareport(data.activeNameOfDatareport)
        }
      },{
        deep:true,
        immediate:true
      })
      // 时间范围选择
      const TimeChange = (date, {start,end}) => {
        console.log(date,searchData.searchDate)
        if (date) {
          searchData[start] = proxy.time(date[0]);
          searchData[end] = proxy.time(date[1]);
          refOfDatareport.value.changeOfDatareport(data.activeNameOfDatareport)
        } else {
          searchData[start] = undefined;
          searchData[end] = undefined;
          searchData.searchDate = []
          setDate()
        }
      }

      const anText = computed(() => ({
        // 新通知使用新的缓存标识，避免勾选过旧公告“不再提示”的用户无法看到
        id: 'sqm_picture_material_mismatch_20260713',
        checkbox: true,
        show: true,
        content: [
          {
            // 图物不符问题排查和提供通知
            title: h_i18n('c388e776d145bfc38f179225375bcbf2'),
            child: [
              {
                value: [
                  // 各供应商合作伙伴
                  { value: '<span style="font-size:16px;">' + h_i18n('4101360c87ee0137fd09e9a024385df4') + '</span>' }
                ]
              },
              {
                value: [
                  // 平台已经发布图物不符问题排查和提供通知，请及时按照要求排查核对，有问题通过平台进行提报，同时提醒所有变更必须按照海尔4M1E变更管理要求系统申报、并经过批准后再实施，一旦违规操作将按照相关合同规定处理！
                  { value: '<span style="font-size:16px;"> '+ h_i18n('f08ac9c2915b37b106ef9530fd0508f6') + '</span>' }
                ]
              },
            ]
          },
          {
            // 供应商管理平台停检单功能升级通知
            // autoHeight: true,
            title: h_i18n('bf5456fa73990270a3e2a69f7cab6421'),
            // subheading: h_i18n('820ec0534fec012ddedd02b462ec22a1'),
            child: [
              {
                value: [
                  { value: '<span style="font-size:16px;">' + h_i18n('820ec0534fec012ddedd02b462ec22a1') + '</span>' }
                ]
              },
              {
                value: [
                  { value: '<span style="font-size:16px;">' + h_i18n('c5e48d1a60b70a1d9774c069de717b0b') + '</span>' }
                ]
              },
              {
                value: [
                  { value: '<span style="font-size:16px;">' + h_i18n('47de640ab73ca761cf99a5b6a1131c12') + '</span>' }
                ]
              }
            ],
            note: '<br/>' + h_i18n('82152526437beed04730b19983adb53c')
          },
          {
            // 仅此长公告使用自适应高度，其他公告保持组件默认样式
            autoHeight: true,
            // 关于新品检测旧系统下线及功能迁移的通知
            title: h_i18n('9202C780A536FC31788E16FAA0B5BBE2'),
            // 尊敬的各位用户：
            subheading: h_i18n('FA4C7C93311E78CF48DDCCA2E04E7AB5'),
            child: [
              {
                value: [
                  // 供应商质量管理平台中旧版样检单操作及新版系统升级说明
                  { value: h_i18n('0C56B8BAAADAAA2CF2292580680FAA8D') },
                  // 旧系统将于2026年8月30日正式下线及功能迁移说明
                  {
                    value: h_i18n('E7C109A2716BADCEC9875B1AC2D7A31+')
                      + '<strong style="color:#f53f3f">'
                      + h_i18n('F6A5610996CE08787CAFD1051980A553')
                      + '</strong>'
                      + h_i18n('6F9563FCC62223BB9BE2D91FC8C0D784')
                  }
                ]
              },
              {
                value: [
                  // 新入口操作路径：
                  { value: '<strong style="font-size:16px;color:#1D2129">' + h_i18n('9C8A744676AFB4170E497017A951A16F') + '</strong>' },
                  // 【新品质量】→【新品检测（旧）】
                  { value: h_i18n('BCCFD915844A7C1CF898D8A6204FB423') }
                ]
              },
              {
                value: [
                  // 已迁移的主要功能：
                  { value: '<strong style="font-size:16px;color:#1D2129">' + h_i18n('8DB189E690C47C5F8C951F5267E8F9E3') + '</strong>' },
                  // 供应商送样——样品送检登记与提交
                  { value: h_i18n('2C75AEEF62BBDAA9B6736BEE6FDA3625') },
                  // 自检报告上传——供应商自检结果文件录入
                  { value: h_i18n('880EA73D960B1754C6D72CB942D1B60A') },
                  // PPAP检验资源上传——PPAP相关检验资料归档
                  { value: h_i18n('4CB5A00ADB8273125D5603E16B277F62') }
                ]
              },
            ],
            // 建议尽快熟悉新入口，如有疑问请联系刘中瑞或张永华协助处理
            note: h_i18n('AF7C8F3CCB43F8A3778A06DB06E38A3A')
              + '<strong>' + h_i18n('7B871E4438EDD8C51DC83F3F3F460F65') + '</strong>'
              + h_i18n('B505660A97C0DDF7D7209D22BC498ED1')
              + '<strong>' + h_i18n('BBEE50E317847FEBE0BE9B10865F52C6') + '</strong>'
              + h_i18n('31FC547F3993EF717FBCB98EAF25CE4F'),
            child2: [{
              value: [
                { value: `<strong style="color:#f53f3f;font-size:16px;">温馨提示： 首次使用新版系统前，建议您先清理浏览器缓存或更换浏览器访问，以避免因缓存导致页面加载异常。各浏览器清理缓存操作路径如下：</strong>` },
              ]
            },
            {
              value: [
                { value: '<strong style="font-size:16px;">' + '浏览器清理缓存路径' + '</strong>'  },
                { value: `Chrome：右上角⋮ → 设置 → 隐私与安全 → 删除浏览数据 → 勾选"Cookie 及其他网站数据"/"缓存的图片和文件" → 点击"从此设备中删除"` },
                { value: `Firefox：右上角☰ → 设置 → 隐私与安全 → 滚动至"浏览数据"→ 点击"清除浏览数据"→ 勾选"Cookie 和网站数据"/"临时缓存文件和页面" → 点击"清除"` },
                { value: `Edge: 右上角点 ⋯ → 设置 → 隐私、搜索和服务 →删除浏览数据 → 立即清除浏览数据后面"选择要清除的内容" → 勾选"Cookie 和其他站点数据"/"缓存的图像和文件" → 点击"立即清除"` },
                { value: `360安全浏览器:右上角☰ → 设置 → 安全设置 → 清理上网痕迹设置...  → 勾选"浏览器缓存的临时文件"/"Cookies 和其他网站数据" → 点击"立即清理"` }

              ]
            }]
          },
          // {
          //   title: h_i18n('0775628dc1ed861c4f99ff33274121c0'),
          //   subheading: h_i18n('de7fe827318468928f23e056b9c50d5d'),
          //   smallTitle: h_i18n('3b160a5d483ec67f8c4687d76928fc5c'),
          //   value: [
          //     h_i18n('a941c736949686a6f85e3c33c4ca2b00'),
          //     h_i18n('39905a504ac7b6c2c4d86529f37b2931'),
          //     h_i18n('5602a63e3e8ef5321b58fc602d5f65cb')
          //   ]
          // },
          {
            title: h_i18n('a7deb625ed114b6ec7e180526fe00a5e'),
            subheading: h_i18n('C6160DF03C697F610263071D6AA1FD04'),
            child:[
              {
                smallTitle: h_i18n('2DEA407D3380D9E1303B3F36DDA55AEF') + ':',
                value: [
                  {value: h_i18n('04B0C2D9063740E42C571C32BDA37A80')},
                  {value: h_i18n('70FDB017650511AEB8B17CFC0C7D0B94'),red:true}
                ],
              },
              {
                smallTitle: h_i18n('500893CCA7FE0D2400116675E1081728') + ':',
                value: [
                  {value:'1、' + h_i18n('AA49FB23ECF9CACF2E8D41EB5247CF23')},
                  {value:'2、' + h_i18n('59600C6BC4A5273CD87BC3D5889292C4')},
                  {value:'3、' + h_i18n('DDB67AE16D0C9B9FB0DB6EA5B69F6408')},
                  {value:'4、' + h_i18n('D2B13102C1FC795201AE43AE1CD6097A'),red:true},
                  {value:'5、' + h_i18n('39568518B9E661E4931286A351842C3E')}
                ],
              }
            ],
            note: h_i18n('5b13e760367093a58b4a23df89784c95')
          },
          // {
          //   title: h_i18n('52258897ad031b04f6d1bfe093adc195'),
          //   subheading: '',
          //   smallTitle: h_i18n('26df25307781d4d912499f1688ef0a97'),
          //   value: [
          //     h_i18n('7691db29ec6b9f60eb17471abe564351'),
          //     h_i18n('505fee7ebf0a6e6fa55c88b1c7c82a01')
          //   ]
          // }
        ]
      }));
      // 海达源 绩效
      const hdyClick = () =>{
        // /user/getPerformanceAddress
        proxy.$http({
          method:'get',
          url:'/base/user/getPerformanceAddress?userId='+userData.userId,
        }).then(res=>{
          if(res.data.data.includes('异常')){
            proxy.warning(res.data.data)
          }else{
            if(!res.data.data){
              proxy.warning(h_i18n('C069C45C390945D8D140C5310714C1AB'))
              return
            }
            window.open(res.data.data)
          }
        })
      }
      // 设置默认时间
      const setDate = () => {
        searchData.searchDate = [new Date().getTime() - 24 * 365 * 60 * 60 * 1000 , new Date()]
        searchData.searchDateStart = proxy.time(new Date().getTime() - 24 * 365 * 60 * 60 * 1000)
        searchData.searchDateEnd = proxy.time(new Date())
        refOfDatareport.value.changeOfDatareport(data.activeNameOfDatareport)
      }
      // 组合参数 Strting
      const makeParams = () => {
        let params = ''
        for (let key in userData) {
          if (userData[key] !== null) {
            params += key + userData[key] + '&'
          }
        }
        return params
      }

      // 计算roleId
      const getRoleId = () =>{
        if(!userData.roleCode){
          return
        }
        let roleConverterSqm = {
          'supplier_general_manager': 13,
          'supplier_deliver_manager': 30,
          'supplier_quality_manager': 7,
          'supplier_quality_chief': 8,
          'supplier_sales_manager': 9
        }
        let roleConverter = {
          'supplier_general_manager': 'S001',
          'supplier_deliver_manager': 'S030',
          'supplier_quality_manager': 'S009',
          'supplier_quality_chief': 'S006',
          'supplier_sales_manager': 'S004'
        }
        let roleId = null
        for (const key in roleConverter) {
          if(roleConverter[key] === userData.roleCode){
            roleId = roleConverterSqm[key]
          }
        }
        return roleId
      }
      // 计算roleName
      const getRoleName = (code) =>{
        if(!userData.roleCode && !code){
          return
        }
        let tempRoleCode = ''
        if(code){
          tempRoleCode = code
        }else {
          tempRoleCode = userData.roleCode
        }
        let roleConverter = {
          'supplier_general_manager': 'S001',
          'supplier_deliver_manager': 'S030',
          'supplier_quality_manager': 'S009',
          'supplier_quality_chief': 'S006',
          'supplier_sales_manager': 'S004'
        }
        let roleConverterName = {
          'supplier_general_manager': h_i18n('06fca431f4ad5efa7871eb756ead58b6'),
          // 'supplier_deliver_manager': '跟单（发货）经理',
          'supplier_deliver_manager': h_i18n('976abc7f8a55866ae953295f7982c619'),
          'supplier_quality_manager': h_i18n('5c575fc2cc4143bcd9c754fdeeecb01a'),
          'supplier_quality_chief': h_i18n('4ed5b49161457958596caef59bfc60b0'),
          'supplier_sales_manager': h_i18n('4c9dcca57920fd8d0eed82311cf80f7d')
        }
        let roleName = null
        for (const key in roleConverter) {
          if(roleConverter[key] === tempRoleCode){
            roleName = roleConverterName[key]
          }
        }
        return roleName
      }
      // 计算roleCode
      const getRoleCode = (code) =>{
        if(!userData.roleName && !code){
          return
        }
        let tempRoleName = ''
        if(code){
          tempRoleName = code
        }else {
          tempRoleName = userData.roleName
        }
        let roleConverter = {
          '总经理': 'S001',
          // '跟单（发货）经理': 'S030',
          '发货经理': 'S030',
          '质量经理': 'S009',
          '质量部长': 'S006',
          '销售经理': 'S004'
        }
        let roleCode = null
        for (const key in roleConverter) {
          if(key === tempRoleName){
            roleCode = roleConverter[key]
          }
        }
        return roleCode
      }
      // 所有角色名
      const getRoleListName = () =>{
        if(!userData.roleCodeList || userData.roleCodeList.length <= 0){
          userData.roleCodeList = [userData.roleCode]
        }
        let roleListName = []
        for(let i = 0 ; i < userData.roleCodeList.length ; i ++){
          roleListName.push(getRoleName(userData.roleCodeList[i]))
        }
        return roleListName
      }
      // 打开/关闭角色切换
      const openUserChange = () =>{
        data.userChangeFlag = !data.userChangeFlag
        if(data.logoutFlag) data.logoutFlag = false
      }
      // 关闭角色切换
      const closeUserChange = () =>{
      if(data.userChangeFlag){
        data.userChangeFlag = false
      }
      if(data.logoutFlag){
        data.logoutFlag = false
      }
      }
      // 切换角色
      const changeRole = (roleCode) =>{
        userData.roleCode = roleCode
        userData.roleName = getRoleName(roleCode)
        userData.roleId = getRoleId()
      }
      // 退出
      const logOutFun = () =>{
        data.logoutFlag = false
        proxy.$router.replace('/login')
      }
      const getCookie = (name) =>{
        const allCookies = document.cookie.split(';');
        if(!allCookies[0]){
          return
        }
        for (let i = 0; i < allCookies.length; i++) {
          const cookieObjStr = allCookies[i].trim();
          // 查找name=部分
          if (cookieObjStr.indexOf(`${name}=`) === 0) {
            // 获取等号后面的部分
            return decodeURIComponent(cookieObjStr.substring(name.length + 1));
          }
        }
        // 如果没有找到对应名称的cookie，则返回null或其他默认值
        return null;
      }
      // 回主页
      const goToHomePage = () => {
        proxy.$router.replace({
          path:'/workbench',
          query:{
            ...userData
          }
        })
      }
      // 待办
      const handleClickTodo = (tab, event) => {
        if (data.myTodoListLoading) {
          return
        }
        refOfTodo.value.changeTodoTab(data.activeNameOfTodo)
      }
      // 我的待办 handleClickactiveNameRightTodo
      const handleClickactiveNameRightTodo = (tab, event) => {
        // console.log(data.activeNameRightTodo)
      }
      // 公告 handleClickNameOfNotice
      const handleClickNameOfNotice = (tab, event) => {
        // getNotice()
        getNoticeSize()
        // console.log(data.activeNameOfNotice)
      }
      // 我的数据 tabs切换
      const handleClickDatareport = (tab, event) => {
        refOfDatareport.value.changeOfDatareport(data.activeNameOfDatareport)
      }
       // 工作场景
      const handleClickScene = (tab, event) => {
        console.log(tab, event);
        // 可能影响高度，公告条数修改
        nextTick(()=>{
          getNoticeSize()
        })
      }
      // 工作台卡片、待办和“更多”都通过 Content 的统一入口跳转，
      // headerRootId 用于确定侧栏分组，currentMenuId 用于精确定位当前子菜单。
      const emitCurrentPageRouter = (url, routerName, headerRootId, currentMenuId = headerRootId) => {
        emit('changeRouter', url, routerName, headerRootId, currentMenuId)
      }
      // 根据工作台卡片传入的资源 ID 查找权限菜单，并发起当前页跳转。
      const navigateTo = (name,code) =>{
        // console.log('name',name)
        // 用名字匹配，权限配置中的名字要和name一致
        let obj = getPath(name,code)
        if(obj){
          // console.log('跳转链接对象',obj)
          data.pathName = name
          data.pathCode = obj.resourceCode
          data.pathUrl = obj.url
          data.resourceId = obj.id
          // console.log('resourceCode---->',data.pathCode)
          if(!data.pathUrl){
            proxy.info(h_i18n('69f28bab80d16769dbf1d0d6c70c7d77'))
            return
          }
          // else if(data.pathUrl.includes('http')){
          //   window.open(obj.url)
          // }else {
          //   window.open('http://sqm-test.qd-huangdao-test.haier.net'+obj.url+"?resourceId=" + obj.id + makeParams())
          // }
        }else{
          proxy.warning(h_i18n('acd5cb847a4aff235c9a01ddeb6f9770'))
          return
        }
        emitCurrentPageRouter(data.pathUrl, data.pathName, data.resourceId, data.resourceId)
      }
      // 从待办数据中拆分侧栏根菜单 ID 和当前菜单 ID，避免父子节点共用一个 ID。
      const getTodoMenuIds = (itemTodo) => {
        const currentMenuId = itemTodo?.id;
        const parentId = itemTodo?.parentId;
        const headerRootId = parentId !== undefined
          && parentId !== null
          && String(parentId) !== ''
          && String(parentId) !== '1'
          ? parentId
          : currentMenuId;
        return { headerRootId, currentMenuId };
      };

      // 校验待办数据后，复用工作台统一路由入口并携带当前菜单 ID。
      const navigateToTodo = (itemTodo) => {
        // 防护：数据未就绪时不跳转
        if (!itemTodo || !itemTodo.url || !itemTodo.id) {
          proxy.warning('待办跳转数据未就绪')
          return
        }
        const { headerRootId, currentMenuId } = getTodoMenuIds(itemTodo);
        emitCurrentPageRouter(itemTodo.url, itemTodo.name, headerRootId, currentMenuId)
      }
      // 获取path
      const getPath = (name,code) =>{
        let pathObj = ''
        pathObj = data.menuList.find(item=>{
          return item.id === name
        })
        return pathObj
      }
      // 查询菜单权限 roleResource/getMenuOneList
      const getMenu = () =>{
        data.menuLoading = true
        proxy.$http({
          method:'get',
          url:`/base/roleResource/getMenuOneList?userId=${userData.userId}&isSupply=${userData.isSupply}&parentResourceCode=SQM&supplyCode=${userData.supplyCode}`,        }).then((res=>{
          if(res.data.code === '0' && res.data.data){
            data.menuList = res.data.data
          }
        })).catch(err=>{
          console.log(err)
        }).finally(()=>{
          // console.log(data.menuList)
          data.menuLoading = false
          // 因为需要高度，获取菜单接口后再调用系统公告
          getNoticeSize()
        })
      }
      // 是否有权限
      const hasPermission = (name,type) =>{
        let flag = data.menuList.some(item=>{
          // 角色菜单权限
          return item.id === name
        })
        if(userData.hCode === 0 && userData.vHcode === 1 && flag){
          flag = true
        }else if(userData.hCode === 0 && userData.vHcode !== 1 && flag){
          flag = false
        }
        // hCode = 0 必须显示GCCC
        if(name === 89 && userData.hCode === 0){
          flag = true
        }
        if(flag){
          if(data[`activeNameOfScene${type}Flag`]){
            data[`activeNameOfScene${type}Flag`] = false
          }
        }
        return flag
      }
      // 新品报验数
      const getNewProductCount = () =>{
        proxy.$http({
          method:'POST',
          url:'/base/hmqm/patternplanCount?supplyCode='+userData.supplyCode,

        }).then((res)=>{
          if(res.data.code === '0'){
            data.newProductCount = res.data.data
          }
        }).catch(err=>{
          console.log(err)
        }).finally(()=>{

        })
      }
       // 停检数 /hmqm/stopCount
      const getStopCount = () =>{
        proxy.$http({
          method:'POST',
          url:'/base/hmqm/stopCount?supplyCode='+userData.supplyCode,

        }).then((res)=>{
          if(res.data.code === '0'){
            data.stopCount = res.data.data
          }
        }).catch(err=>{
          console.log(err)
        }).finally(()=>{

        })
      }
      // 抱怨单数 /hmqm/complainCount
      const getComplainCount = () =>{
        proxy.$http({
          method:'POST',
          url:'/base/hmqm/complainCount?supplyCode='+userData.supplyCode,

        }).then((res)=>{
          if(res.data.code === '0'){
            data.complainCount = res.data.data
          }
        }).catch(err=>{
          console.log(err)
        }).finally(()=>{

        })
      }
        // BOM
      const getIsBOM = () =>{
        proxy.$http({
          method:'post',
          url:'/base/hmqm/bomSupplyList',
        }).then((res)=>{
          if(res.data.code === '0' && res.data.data){
            let bomList = res.data.data
            data.isBOM = bomList.includes(userData.supplyCode?.toUpperCase())
          }
        }).catch(err=>{
          console.log(err)
        }).finally(()=>{

        })
      }
      // 从子组件获取待办列表 getTodo
      const getTodo = (todoList) =>{
        data.myTodoList = todoList
      }
      // 从子组件获取 loading 状态
      const onTodoLoading = (loading) => {
        data.myTodoListLoading = loading
      }
      // 待办组件回传点击事件后，先拆分父级和当前菜单，再交给 Content 统一处理。
      const changeRouterTodo = (obj) => {
        const { headerRootId, currentMenuId } = getTodoMenuIds(obj);
        emitCurrentPageRouter(obj.url, obj.name, headerRootId, currentMenuId)
      }

      // ========== 我的通知 ==========
      const getMyNotifyList = () => {
        data.myNotifyListLoading = true
        proxy.$http({
          method: 'post',
          url: '/base/supplyUserMessage/list',
          data: { supplyCode: userData.supplyCode, userId: userData.userId, userName: userData.userName, pageNo: 1, pageSize: 50 }
        }).then((res) => {
          if (res.data.code === '200' && res.data.data) {
            data.myNotifyList = res.data.data.records || []
            data.filteredNotifyList = [...data.myNotifyList]
          }
        }).catch(err => { console.log(err) }).finally(() => { data.myNotifyListLoading = false })
        // 状态数量
        proxy.$http({
          method: 'post',
          url: '/base/supplyUserMessage/statusCount',
          data: { supplyCode: userData.supplyCode, userId: userData.userId, userName: userData.userName }
        }).then((res) => {
          if (res.data.code === '200' && res.data.data) {
            data.unreadNotifyCount = res.data.data.unReadCount || 0
            data.readNotifyCount = res.data.data.readCount || 0
            data.totalNotifyCount = res.data.data.count || 0
          }
        })
      }
      const filterNotify = (type) => {
        data.notifyFilter = type
        data.myNotifyListLoading = true
        const params = { supplyCode: userData.supplyCode, userId: userData.userId, userName: userData.userName, pageNo: 1, pageSize: 50 }
        if (type === 'unread') params.pushStatus = 1
        else if (type === 'read') params.pushStatus = 2
        proxy.$http({
          method: 'post',
          url: '/base/supplyUserMessage/list',
          data: params
        }).then((res) => {
          if (res.data.code === '200' && res.data.data) {
            data.filteredNotifyList = res.data.data.records || []
          }
        }).catch(err => { console.log(err) }).finally(() => { data.myNotifyListLoading = false })
        // 同步刷新数量
        proxy.$http({
          method: 'post',
          url: '/base/supplyUserMessage/statusCount',
          data: { supplyCode: userData.supplyCode, userId: userData.userId, userName: userData.userName }
        }).then((res) => {
          if (res.data.code === '200' && res.data.data) {
            data.unreadNotifyCount = res.data.data.unReadCount || 0
            data.readNotifyCount = res.data.data.readCount || 0
            data.totalNotifyCount = res.data.data.count || 0
          }
        })
      }
      const handleNotifyFilterChange = () => {
        filterNotify(data.notifyFilter)
      }
      const markAsRead = (items) => {
        const list = Array.isArray(items) ? items : [items]
        const unreadList = list.filter(r => r.pushStatus === 1)
        if (unreadList.length === 0) return
        data.myNotifyListLoading = true
        const ids = unreadList.map(r => r.id)
        proxy.$http({ method: 'post', url: '/base/supplyUserMessage/clickStatus', data: ids }).then((res) => {
          if (res.data.code === '200') {
            filterNotify(data.notifyFilter)
          }
        }).catch(() => { data.myNotifyListLoading = false })
      }
      const openNotifyDrawer = () => {
        data.notifyDrawerVisible = true
        data.drawerNotifyPageNo = 1
        data.drawerSelectedRows = []
        getDrawerNotifyList()
      }
      const onNotifyDrawerClose = () => {
        drawerSearch.pushStatus = null
        filterNotify(data.notifyFilter)
      }
      const getDrawerNotifyList = () => {
        data.drawerNotifyLoading = true
        const params = { supplyCode: userData.supplyCode, userId: userData.userId, userName: userData.userName, pageNo: data.drawerNotifyPageNo, pageSize: data.drawerNotifyPageSize }
        if (drawerSearch.pushStatus) params.pushStatus = drawerSearch.pushStatus
        proxy.$http({
          method: 'post',
          url: '/base/supplyUserMessage/list',
          data: params
        }).then((res) => {
          if (res.data.code === '200' && res.data.data) {
            data.drawerNotifyList = res.data.data.records || []
            data.drawerNotifyTotal = res.data.data.total || 0
          }
        }).catch(err => { console.log(err) }).finally(() => { data.drawerNotifyLoading = false })
      }
      const handleCurrentChange = () => {
        data.drawerNotifyPageNo = 1
        data.drawerSelectedRows = []
        getDrawerNotifyList()
      }
      const handleDrawerPageChange = () => { data.drawerSelectedRows = []; getDrawerNotifyList() }
      const handleDrawerSelectionChange = (rows) => { data.drawerSelectedRows = rows }
      const checkSelectable = (row) => { return row.pushStatus === 1 }
      const batchMarkAsRead = () => {
        if (data.drawerSelectedRows.length === 0) {
          proxy.info(h_i18n('84d39926fb38a6332e88e19c6aa429c4'))
          return}
        const unreadRows = data.drawerSelectedRows.filter(r => r.pushStatus === 1)
        if (unreadRows.length === 0) {
          proxy.info(h_i18n('708c9d6d2ad108ab2c560530810deae9')+h_i18n('a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6')+h_i18n('g1h2i3j4k5l6m7n8o9p0q1r2s3t4u5v6'))
          return}
        const ids = unreadRows.map(r => r.id)
        proxy.$http({ method: 'post', url: '/base/supplyUserMessage/clickStatus', data: ids }).then((res) => {
          if (res.data.code === '200') {
            data.drawerSelectedRows = []
            getDrawerNotifyList()
            getMyNotifyList()
          }
        })
      }
      // ========== 我的通知 END ==========

      // 变更角色
      const changeUserRole = (item) =>{
        data.workBenchLoading = true
        for (const key in userData) {
          userData[key] = localStorage.getItem(key) || route.query[key]
        }
        userData.roleName = item
        // 变更roleName后更新roleCode
        // userData.roleCode = getRoleCode(item)
        // roleCode变更后更新对应的roleId
        // userData.roleId = getRoleId()
        // console.log('changeUserRole::::')
        setDate()
        getMenu()
        getNewProductCount()
        getStopCount()
        getComplainCount()
        getIsBOM()
        refOfTodo.value.getTreeList()
        data.activeNameOfTodo = h_i18n('fbea1c48071d7e43df61837cdfbd8a96')
        setTimeout(() => {
          data.workBenchLoading = false
        }, 1500);
        getBtn()
        getMyNotifyList()
      }
    // 查询公告
    const getNotice = () =>{
      if(data.activeNameOfNotice === "系统公告"){
        data.noticeType = '1'
      }else if(data.activeNameOfNotice === "操作指导书"){
        data.noticeType = '2'
      }else if(data.activeNameOfNotice === "常见问题"){
        data.noticeType = '4'
      }
      data.noticeLoading = true
      proxy.$http({
        method:'post',
        url:"/base/notice/list",
        data: {
          visibleType: '2',
          noticeType: data.noticeType,
          current: 1,
          size: data.noticeSize,
        },
      }).then((res)=>{
        if(res.data.code === '0'){
          data.noticeList = res.data.data.records
        }
      }).catch(err=>{
        console.log(err)
      }).finally(()=>{
        data.noticeLoading = false
      })
    }
    // 打开pdf
    const openUrl = (row) => {
        if(row.fileUuid.includes('https')){
          window.open(row.fileUuid)
        }else{
          window.open(`https://sqm.haier.net/readFile/${row.fileUuid}`)
        }
      }
    // 根据当前通知页签选择对应资源，并通过统一路由入口打开更多列表。
    const openMore = () => {
      // 写死权限中心的id
      let pathName = 92
      if(data.activeNameOfNotice === "系统公告"){
        data.noticeType = '1'
        pathName = 99
      }else if(data.activeNameOfNotice === "操作指导书"){
        data.noticeType = '2'
        pathName = 92
      }else if(data.activeNameOfNotice === "常见问题"){
        data.noticeType = '4'
        pathName = 94
      }
      
      let obj = getPath(pathName)
      let pathUrl = obj.url
      let resourceId = obj.id
      emitCurrentPageRouter(pathUrl, pathName, resourceId, resourceId)
      
        // proxy.$router.push({
        //   path:'/SystemNotice',
        //   query:{
        //     supplyCode:userData.supplyCode,
        //     activeName:data.noticeType,
        //     name:userData.supplyCode,
        //     nickName:userData.trueName,
        //     dataFrom:'sqm',
        //     roleCode:userData.roleCode,
        //   }
        // })
      
      }
    // 获取用户数据
    const getUserData = () =>{
      for (const key in userData) {
        userData[key] = localStorage.getItem(key)
      }
       // 供应商编码
      userData.supplyCode = getCookie('supplyCode') || localStorage.getItem('supplyCode') || route.query.supplyCode || getCookie('vCode') || localStorage.getItem('vCode') || route.query.vCode || getCookie('supplierNo')
      // 供应商名称
      userData.supplyName = getCookie('supplyName') || localStorage.getItem('supplyName') || route.query.supplyName || getCookie('companyName') || localStorage.getItem('companyName') || route.query.companyName
      // 角色编码
      userData.roleCode = getCookie('roleCode') || localStorage.getItem('roleCode') || route.query.roleCode
      // 角色名称
      userData.roleName = getCookie('roleName') || localStorage.getItem('roleName') || route.query.roleName || getRoleName()
      // 角色ID
      userData.roleId = getCookie('roleId') || localStorage.getItem('roleId') || route.query.roleId || getRoleId()
      // 角色组
      userData.roleCodeList = getCookie('roleCodeList') || localStorage.getItem('roleCodeList') || (route.query.roleCodeList && route.query.roleCodeList.split(','))
      // 角色组名称
      userData.roleNameList = getCookie('roleNameList') || localStorage.getItem('roleNameList') || route.query.roleNameList || getRoleListName()
      // 用户编码
      userData.userCode = getCookie('userCode') || localStorage.getItem('userCode') || route.query.userCode
      // 用户登录名称
      userData.userName = getCookie('userName') || localStorage.getItem('userName') || route.query.userName || getCookie('username') || localStorage.getItem('username') || route.query.username
      // 用户真实名称
      userData.trueName = getCookie('trueName') || localStorage.getItem('trueName') || route.query.trueName
      // 用户ID
      userData.userId = getCookie('userId') || localStorage.getItem('userId') || route.query.userId
      // isSupply
      userData.isSupply = getCookie('isSupply') || localStorage.getItem('isSupply') || route.query.isSupply
      // 数据来源
      // dataFrom
      userData.dataFrom = getCookie('dataFrom') || localStorage.getItem('dataFrom') || route.query.dataFrom
      // 很小众
      // GCCC hCode
      userData.hCode = getCookie('hCode') || localStorage.getItem('hCode') || route.query.hCode || getCookie('h') || localStorage.getItem('h')
      userData.hCode ? userData.hCode = Number(userData.hCode) : null
      // 芯片供应商 是否有其他菜单权限 vHcode
      userData.vHcode = getCookie('vHcode') || localStorage.getItem('vHcode') || route.query.vHcode || getCookie('v') || localStorage.getItem('v')
      userData.vHcode ? userData.vHcode = Number(userData.vHcode) : null
      // type
      userData.type = getCookie('type') || localStorage.getItem('type') || route.query.type
      // status
      userData.status = getCookie('status') || localStorage.getItem('status') || route.query.status
      // applyName
      userData.applyName = getCookie('applyName') || localStorage.getItem('applyName') || sessionStorage.getItem('applyName') || route.query.applyName
      // 待办使用
      // sqmToDoKey
      userData.sqmToDoKey = route.query.sqmToDoKey || localStorage.getItem('sqmToDoKey')
      // 菜单权限
      // resourceId
      // userData.resourceId = getCookie('resourceId') || localStorage.getItem('resourceId') || route.query.resourceId
      // 按钮权限
      // parentId
      userData.parentId = getCookie('parentId') || localStorage.getItem('parentId') || route.query.parentId

      // userData.roleName = getRoleName(userData.roleCode)
      // userData.roleId = getRoleId()
      // console.log(userData)
    }
    // 在会影响高度的地方调用此方法
    const getNoticeSize = () => {
      // 获取公告高度 根据高度计算获取数据数量
      let domOfNotice = document.querySelector(".workbench_middle_right_C_style")?.offsetHeight
      // 头部 70 行高 line-height: 50px
      data.noticeSize = parseInt((domOfNotice - 70 )/50)
      // console.log('data.noticeSize',data.noticeSize)
      getNotice()
    }

  onMounted(()=>{
    // 获取角色信息
    getUserData()
    // 保存路由参数
    // data.enterQuery = route.query
    setDate()
    getMenu()
    getNewProductCount()
    getStopCount()
    getComplainCount()
    getIsBOM()
    emit("initialize")
    getBtn()
    getMyNotifyList()
  })
  const getBtn = () => {
    proxy.getButtonFromSqm(10000,userData.roleCode).then(res=>{
      if(res.length > 0){
        data.btnListOfSqm = res
        console.log('btnListOfSqm',data.btnListOfSqm)
      }else{
        data.btnListOfSqm = []
        data.activeNameRightTodo = '我的待办'
      }
    })
  }
      const language_tab = () => {
        return store.state.i18n.language;
      };
      return{
        getBtn,
        changeUserRole,
        hdyClick,
        refOfDatareport,
        language_tab,
        refOfTodo,
        route,
        userData,
        data,
        searchData,
        drawerSearch,
        TimeChange,
        getCookie,
        handleClickTodo,
        handleClickactiveNameRightTodo,
        handleClickNameOfNotice,
        handleClickDatareport,
        handleClickScene,
        navigateTo,
        hasPermission,
        getTodo,
        onTodoLoading,
        openUrl,
        openMore,
        navigateToTodo,
        changeRouterTodo,
        anText,
        h_i18n,
        roleName,
        // 我的通知
        getMyNotifyList,
        filterNotify,
        handleNotifyFilterChange,
        markAsRead,
        openNotifyDrawer,
        onNotifyDrawerClose,
        handleCurrentChange,
        getDrawerNotifyList,
        handleDrawerPageChange,
        handleDrawerSelectionChange,
        checkSelectable,
        batchMarkAsRead
      }
    }
  })
</script>

<style lang="scss">
  .workbench_style{
    font-size: 16px;
    font-family: "PingFang SC,Microsoft YaHei";
    color: #1D2129;
    letter-spacing: 1px;
    width: 100%;
    min-width: 1200px;
    display: flex;
    flex-flow: column;
    overflow-x: auto;
    margin-bottom: 47px;
    // margin-bottom: 20px;
    .el-tabs__item{
      font-size: 16px;
      color: #1D2129;
      text-shadow: 0.1px 0 #1D2129;
      height:48px;
    }
    .is-active{
      color: #165dff;
      text-shadow: 0.1px 0 #165dff;
    }
    .workbench_top_style{
      width: 100%;
      height: 60px;
      background-color: #386DFF;
      display: flex;
      flex-flow: row;
      .meunLeft{
        padding-left: 10px;
        line-height: 60px;
        .logoHDY{
          cursor: pointer;
        }
      }
      .meunMiddleB{
        width: calc(100vw - 200px - 370px);
        height: 60px;
      }
      .meunMiddleS{
        width: calc(100vw - 200px - 220px);
        height: 60px;
      }
      .menuRight{
        display: inline-flex;
        height: 60px;
        font-size: 16px;
        color: #FFF;
        // .menuRight1{
        //   height: 60px;
        //   width: 80px;
        //   line-height: 60px;
        //   .menuRight1_text{
        //     display: contents;
        //     overflow: hidden;
        //     text-overflow: ellipsis;
        //     white-space: nowrap;
        //     cursor: pointer;
        //   }
        // }
        // .menuRight1::after{
        //   content: '|';
        //   color: #FFF;
        // }
        .menuRight2{
          height: 20px;
          width: 100px;
          line-height: 20px;
          margin-top: 20px;
          display: flex;
          .menuRight2_text{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 75%;
            height: 20px;
          }
          .menuRight2_down{
            cursor: pointer;
            transform: rotate(135deg);
            border-top: 1px solid #FFF;
            border-right: 1px solid #FFF;
            height: 14px;
            width: 14px;
            height: 8px;
            width: 8px;
            margin-left: 5px;
            margin-top: 5px;
          }
        }
        .menuRight3{
          display: flex;
          height: 40px;
          max-width: 260px;
          min-width: 110px;
          margin-top: 20px;
          .menuRight3_image{
            padding-right: 5px;
          }
          .menuRight3_text{
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
            height: 20px;
          }
          .menuRight3_text:hover{
            white-space: normal;
            line-height: 20px;
          }
        }
        .menuRight3::before{
          content: '|';
          color: #FFF;
          padding-right: 5px;
          height: 20px;
        }
      }
    }
    .workbench_middle_style{
      width: auto;
      // height: calc(100vh - 60px);
      display: flex;
      .workbench_middle_left_style{
        // width: calc(100vw - 419px);
        width: 71%;
        min-width: 1060px;
        padding: 0;
        display: flex;
        flex-flow: column;
      }
      .workbench_middle_right_style{
        width: 29%;
        // width: 408px;
        min-width: 408px;
        padding: 0;
        display: flex;
        justify-content: flex-start;
        flex-flow:column;
        .workbench_middle_right_A_style{
          width: 100%;
          height: 392px;
          background-color: #FFF;
          border-radius: 10px;
          padding-top: 8px;
          .workbench_middle_right_notice_list_style{
            margin: 0 16px;
          }
          .A_style{
            overflow-y: auto;
            overflow-x: hidden;
            height: calc(100% - 70px);
            .A_style_todo{
              height: 40px;
              line-height: 40px;
              background-color: #F7F8FA;
              width: calc(100% - 32px);
              font-size: 14px;
              margin: 8px 12px;
              padding-left: 12px;
              border-radius: 8px;
              border: #F7F8FA 1px solid;
              .A_style_todo_span{
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                display: inline-block;
                width: calc(100% - 85px)
              }
              .A_style_todo_button{
                float: right;
                border: 1px solid #ccc;
                margin: 4px;
              }

            }
            // .A_style_todo:hover{
            //   cursor: pointer;
            //   background-color: #e8f3ffc4;
            //   border: #e8f3ff 1px solid;
            // }
          }
        }
        .workbench_middle_right_B_style{
          display: block;
          width: 100%;
          height: 200px;
          background-color: transparent;
          border-radius: 10px;
          margin: 15px 0;
          overflow: hidden;
          position: relative;
          .workbench_middle_right_B_back_style{
            // background: url('../assets/images/hdy_back.png');
            // width: 100%;
            // background-size: cover;
            object-fit: fill;
            width: 100%;
            height: 200px;
          }
          .righ_link_style{
            position: absolute;
            bottom: 25%;
            left: 10%;
          }
        }
        .workbench_middle_right_C_style{
          width: 100%;
          height: 635px;
          overflow-y: auto;
          background-color: #FFF;
          border-radius: 10px;
          position: relative;
          margin-top: 16px;
          padding-top: 8px;
          .workbench_middle_right_notice_style{
            margin: 0 16px;
            margin-bottom: 6px;
            .el-tabs__item{
              max-width: 150px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
          .rightNotice_more_style{
            font-size: 12px;
            color: #86909C;
            width: 75px;
            position: absolute;
            top: 20px;
            right: 10px;
            cursor: pointer;
          }
          .rightNotice_more_style:hover{
            color: #165DFF;
          }
          .rightNotice_style{
            margin: 0 16px;
            min-height: 280px;
            .right_notice_style{
              display: flex;
              height: 50px;
              // margin-bottom: 16px;
              .rightNotice_style_left{
                cursor: pointer;
                width: calc(100% - 88px);
                font-size: 14px;
                color: #1D2129;
                overflow: hidden;
                white-space: nowrap;
                word-break: break-all;
                text-overflow: ellipsis;
                line-height: 25px;
              }
              .rightNotice_style_left:hover{
                color: #165DFF;
                white-space: normal;
                word-break: break-all;
                text-overflow: clip;
                overflow: visible;
              }
              // .rightNotice_style_left:hover +.rightNotice_style_date{
              //   line-height: 50px;
              // }
              .rightNotice_style_date{
                width: 88px;
                font-size: 13px;
                color: #86909C;
                text-align: right;
                line-height: 25px;
              }
            }
          }
          .rightGuide_style{

          }
          .rightQuestions_style{

          }
        }
        .workbench_middle_right_D_style{
          background-color: #FFF;
          flex-grow: 1;
          margin-bottom: 16px;
          border-radius: 10px;
        }
      }
      .workbench_middle_left_style{
        .workbench_middle_left_line_style{
          display: flex;
          flex-flow: row;
        }
        // display: flex;
        // flex-flow: row;
        // flex-wrap: wrap;
        // align-content: flex-start;
       .workbench_middle_left_one_style{
        width: calc(40% - 16px);
        height: 150px;
        margin-right: 16px;
        .backlog {
          width: 100%;
        .personalInformation {
          width: 100%;
          height: 150px;
          background: url('../assets/images/bg1.png') no-repeat center;
          background-size: 100% 100%;
          border-radius: 10px;
          padding: 13px;
          box-sizing: border-box;

          .title {
            color: #fff;
            font-size: 16px;
            width: 100%;
            font-weight: 900;
            // font-family: "Microsoft YaHei";
            margin: 0;
          }

          .per_footer {
            display: flex;
            align-items: center;
            margin-top: 15px;

            p {
              margin: 0;
              padding: 0;

            }

            img {
              width: 72px;
              height: 72px;
            }

            .per_f_right {
              width: 78%;
              margin-left: 10px;

              .nameText {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 8px;

                .text_name {
                  font-size: 17px;
                  // font-family: 'Microsoft YaHei';
                  font-weight: bold;
                  color: #fff;
                }
              }

            }

          }
        }


      }
    }
    .workbench_middle_left_two_style{
      width: calc(60% - 16px);
      height: 150px;
      border-radius: 10px;
      background: #fff;
      .monthly_portrait {
        width: 100%;
      height: auto;
      border-radius: 10px;
      float: left;
      // margin-top: 12px;
        .monthly_portrait_p{
          width: 100%;
        // height: 70px;
        // background:lightgreen;
        // line-height: 70px;
        margin: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
          .monthly_portrait_title {
            font-size: 16px;
            font-family: "PingFang SC,Microsoft YaHei";
            font-weight: 900;
            margin: 15px 16px 0 16px;
            height: 40px;
            line-height: 40px;
            color: #1D2129;
          }
          }
      }
      .monthly_portrait_bottom_style{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        width: 100%;
        padding-top: 16px;
        .monthly_portrait_div_style{
          font-size: 16px;
          .monthly_portrait_div_c1_style{
            width: 100px;
            height: 20px;
            color:#4E5969;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          .monthly_portrait_div_c2_style{
            font-size: 24px;
            line-height: 34px;
            width: 25px;
            color:#165DFF;
            font-weight: 600;
            margin-top: 8px;
          }
        }
      }
    }
    .workbench_middle_left_three_style{
      width: calc(100% - 16px);
      .scene {
        width: 100%;
        height: auto;
        background: #fff;
        border-radius: 10px;
        float: left;
        margin-top: 16px;
        padding-bottom: 10px;
        .nodata-style{
          width:96px;
          font-size: 14px;
          color:#86909c;
          height: 30px;
          line-height: 30px;
          text-align: center;
          margin-bottom: 16px;
        }

      .scene_header {
        width: 100%;
        // height: 70px;
        // background:lightgreen;
        // line-height: 70px;
        margin: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;



        .el-dropdown-menu {
          top: 750px !important;
          position: absolute;
          left: 990px !important;
        }
        .scene_header_text {
          color: #1d2129;
          font-size: 16px;
          // font-family: "Microsoft YaHei";
          font-weight: 900;
          // height: 30px;
          // line-height: 30px;
          // margin: 12px;
          margin: 15px 16px 0 16px;
        }

      }
      .scene_tabs_style{
        margin: 8px 16px 8px 16px;
        font-size: 16px;
      }

      ul {
        width: 100%;
        height: auto;
        min-height: 100px;
        display: flex;
        // justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        list-style: none;
        margin: 0;
        padding: 0;
        // padding:0 30px;
        li {
          width: 11.11%;
          min-width: 100px;
          height: 100px;
          margin: 0;
          padding: 0;
          display: flex;
          flex-flow: column;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          text-align: center;
          .hover_div_style{
            width: 110px;
            height: 90px;
            position: absolute;
            transform: translateY(-7px);
          }
          p {
            font-size: 14px;
            margin-top: 10px;
            z-index: 2;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 80%;
            // font-family: "Microsoft YaHei";
          }

          img {
            width: 40px;
            height: 40px;
            z-index: 2;
          }
        }
        li:hover{
          .hover_div_style{
            background-color: #e8f3ffc4;
            z-index: 1;
            border-radius: 8px;
          }
          p{
            white-space:normal;
            text-overflow: inherit;
            text-align: center;
          }
        }
      }

      }
    }
    .workbench_middle_left_four_style{
      width: calc(100% - 16px);
      // min-height: 338px;
      .todo_list_style{
        position: relative;
        width: 100%;
        height: 330px;
        background: #fff;
        border-radius: 10px;
        float: left;
        margin-top: 16px;
        .todo_list_title_style{
          // width: 100%;
          // height: 30px;
          // line-height: 30px;
          // margin-top: 15px;
          // span{
          //   color: #1d2129;
          //   font-size: 16px;
          //   font-family: "Microsoft YaHei";
          //   font-weight: 900;
          //   margin: 0 16px;
          // }
        }
        .todo_list_tabs_style{
          margin: 8px 16px 8px 16px;
        }
        .todo_list_right_title_style{
          position: absolute;
          right: 0px;
          font-size: 14px;
          transform: translate(-15px, -43px);
        }
      }
    }
    .workbench_middle_left_five_style{
      width: calc(100% - 16px);
      .datareport {
        position: relative;
      width: 100%;
      height: 392px;
      background: #fff;
      border-radius: 10px;
      float: left;
      margin-top: 16px;

      .datareport_header {
        // width: 100%;
        // height: 30px;
        // line-height: 30px;
        margin-top: 8px;

        .datareport_header_text {
          color: #1d2129;
          font-size: 16px;
          // font-family: "Microsoft YaHei";
          font-weight: 900;
          margin: 0 16px;
        }
        .datareport_tabs_style{
          margin: 0 16px;
          margin-bottom: 12px;
        }
        .is-hwork{
          min-width: 361px !important;
          .el-range-separator{
            line-height: 30px !important;
          }
          .el-input__inner{
            input{
              width: 70px !important;
            }
          }
          .el-range__close-icon{
            line-height: 35px !important;
          }
          .el-range__close-icon::before{
            margin-left: 2px;
          }
        }
        .datareport_date_style{
          position: relative;
          .datareport_date_page_style{
            position: absolute;
            right: 0px;
            top: -76px;
            width: 361px;
            .hwork_other_style{
              min-width: 361px !important;
              .el-input__inner{
                width: 361px !important;
                height: 36px;
                input{
                  width: 70px !important;
                }
              }
              .el-range-editor::before{
                content:'月份区间选择';
                margin-left: -124px;
                margin-right: 10px;
              }
            }
          }
          .datareport_date_page_style_en{
            position: absolute;
            right: 0px;
            top: -76px;
            width: 361px;
            .hwork_other_style{
              min-width: 361px !important;
              .el-input__inner{
                width: 361px !important;
                height: 36px;
                input{
                  width: 70px !important;
                }
              }
              .el-range-editor::before{
                content:'Month Selection';
                margin-left: -124px;
                margin-right: 10px;
              }
            }
          }
          .el-input__inner{
            width: 200px;
          }
            .el-icon-date{
              line-height: 20px;
            }
            .el-range-separator{
              line-height: 20px;
            }
            .el-range__close-icon{
              line-height: 30px;
            }
            .el-range-input{
              line-height: 20px;
              width: 70px;
              text-align: center;
            }

        }
        .workbench_card_style{
          margin-left: 16px;
        }

        .active {
          color: #269af3;
          font-weight: bold;
        }

      }

    }
    }
    .workbench_middle_left_six_style{
      width: calc(100% - 16px);
      min-height: 136px;
      border-radius: 10px;
      background-color: #FFF;
      margin: 16px 0;
      .workbench_middle_left_six_title_style{
        width: 100%;
        height: 30px;
        line-height: 30px;
        color: #1d2129;
        font-size: 16px;
        // font-family: "Microsoft YaHei";
        font-weight: 900;
        margin: 15px 12px 0 16px;
      }
      ul {
        width: calc(100% - 32px);
        height: 120px;
        display: flex;
        // justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
        list-style: none;
        margin: 0;
        padding: 0 16px;
        font-size: 16px;
        font-weight: 600;

        li:nth-child(1) {
          width: calc(25% - 15px);
          height: 90px;
          margin: 0;
          // padding:10px 20px;
          padding: 0;
          background: url('../assets/images/kc.png') no-repeat center;
          background-size: 100% 100%;
          margin-right: 20px;
          cursor: pointer;
          display: flex;
          span {
            margin: auto 24px;
            // font-family: "Microsoft YaHei";
            color: #746BE7;

          }
        }

        // li:nth-child(2) {
        //   width: calc(25% - 15px);
        //   height: 90px;
        //   margin: 0;
        //   padding: 0;
        //   background: url('../assets/images/xt.png') no-repeat center;
        //   background-size: 100% 100%;
        //   margin-right: 20px;
        //   cursor: pointer;
        //   span {
        //     margin-left: 24px;
        //     line-height: 90px;
        //     // font-family: "Microsoft YaHei";
        //     color:#D17614;
        //   }
        // }

        li:nth-child(2) {
          width: calc(25% - 15px);
          height: 90px;
          margin: 0;
          padding: 0;
          background: url('../assets/images/flow.png') no-repeat center;
          margin-right: 20px;
          // border-radius:11px;
          background-size: 100% 100%;
          display: flex;
          cursor: pointer;
          span {
            margin: auto 24px;
            // font-family: "Microsoft YaHei";
            color: #00A189;
          }
        }

        li:nth-child(3) {
          width: calc(25% - 15px);
          height: 90px;
          margin: 0;
          padding: 0;
          background: url('../assets/images/problem.png') no-repeat center;
          background-size: 100% 100%;
          // margin-right: 20px;
          display: flex;
          cursor: pointer;
          span {
            margin: auto 24px;
            // font-family: "Microsoft YaHei";
            color: #0865D8;
          }
        }
      }
    }
  }


    }
    .workbench_bottom_style{
      width: 100%;

    }
  }
  @media (max-width: 1199px) {
    .workbench_style{
      overflow-x:unset;
    }
  }

  @media (max-width: 991px) {
    .workbench_style{
      overflow-x:unset;
    }
  }
  @media (max-width: 767px) {
    .workbench_style{
      overflow-x:unset;
    }
  }
  @media (max-width: 480px) {
    .workbench_style{
      overflow-x:unset;
    }
  }
  .menuRight2_user{
    height: 30px;
    line-height: 30px;
    color: #1d2129;
    text-align: center;
    cursor: pointer;
    margin-bottom: 5px;
  }
  .menuRight2_user:hover{
    background-color: #386DFF;
    color: #FFF;
    border-radius: 8px;
  }
  .menuRight2_user_blue{
    height: 30px;
    line-height: 30px;
    background-color: #aaabad;
    color: #FFF;
    border-radius: 8px;
    text-align: center;
    margin-bottom: 5px;
  }
  .menuRight3_logout{
    height: 30px;
    line-height: 30px;
    color: #1d2129;
    text-align: center;
    cursor: pointer;
    margin-bottom: 5px;
  }
  .menuRight3_logout:hover{
    background-color: #386DFF;
    color: #FFF;
    border-radius: 8px;
  }
  // ========== 我的通知样式 ==========
  .notify_tab_badge {
    .el-badge__content {
      top: 6px !important;
      right: -4px !important;
    }
  }
  .notify_content_style {
    .notify_sub_bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #E5E6EB;
      margin: 0 16px 4px 16px;
      .notify_filter_tabs {
        flex: 1;
        .el-tabs__header {
          margin: 0;
          border-bottom: none;
        }
        .el-tabs__item {
          font-size: 13px !important;
          height: 30px !important;
          line-height: 30px !important;
          padding: 0 10px !important;
          em {
            font-style: normal;
            margin-left: 4px;
          }
        }
        .el-tabs__item.is-active {
          background-color: #E8F3FF;
          color: #165DFF;
          font-weight: 600;
        }
      }
      .notify_more_btn {
        font-size: 12px;
        color: #86909C;
        cursor: pointer;
        white-space: nowrap;
        &:hover { color: #165DFF; }
      }
    }
    .notify_card_list {
      overflow-y: auto;
      height: calc(100% - 40px);
      padding: 0 16px;
      .notify_card_item {
        display: flex;
        align-items: flex-start;
        padding: 10px 0;
        border-bottom: 1px solid #F2F3F5;
        cursor: pointer;
        &:last-child { border-bottom: none; }
        &:hover { background-color: #F7F8FA; }
        .notify_card_left {
          flex-shrink: 0;
          margin-right: 10px;
          .notify_tag {
            display: inline-block;
            font-size: 12px;
            padding: 2px 8px;
            border-radius: 4px;
            &.unread { background-color: #FFF7E8; color: #FF7D00; }
            &.read { background-color: #F2F3F5; color: #86909C; }
          }
        }
        .notify_card_right {
          flex: 1;
          min-width: 0;
          .notify_card_content {
            font-size: 14px;
            color: #1D2129;
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .notify_card_meta {
            font-size: 12px;
            color: #C9CDD4;
            margin-top: 4px;
          }
        }
        &:hover {
          .notify_card_right > .notify_card_content {
            -webkit-line-clamp: unset;
            -webkit-box-orient: unset;
            display: block;
            overflow: visible;
            text-overflow: unset;
          }
        }
      }
    }
  }
  // 通知抽屉样式
  .notify_drawer_class {
    top: 50px !important;
    height: calc(100vh - 50px) !important;
    .el-drawer__header {
      margin-bottom: 0;
      padding-bottom: 10px;
      border-bottom: 1px solid #ccc;
      font-size: 16px;
      color: #1D2129;
      font-weight: bold;
    }
    .drawer_page{
      width: 668px;
      min-width: 668px;
      padding: 0;
    }
    .el-drawer__body {
      overflow-y: auto;
      padding: 16px;
    }
  }
</style>